// Hindi language file
export const HI = {
  preparing_zip: "ज़िप तैयार किया जा रहा है…",
  compressing: "संपीड़ित किया जा रहा है…",
  info_icon: "एक बार पूर्ण के रूप में चिह्नित करने के बाद, कोई अतिरिक्त सदस्य शामिल नहीं हो सकते या जोड़े जा सकते हैं, और सभी चैट समूह निष्क्रिय हो जाएंगे। कृपया ध्यान दें कि प्रोजेक्ट, सभी चैट समूहों और डेटा के साथ, निष्क्रिय स्थिति में सुलभ रहेगा।",
  mark_is_done: "क्या आप वाकई प्रोजेक्ट को पूर्ण के रूप में चिह्नित करना चाहते हैं? एक बार चिह्नित करने के बाद, कोई अतिरिक्त सदस्य शामिल नहीं हो सकते या जोड़े जा सकते हैं, और सभी चैट समूह निष्क्रिय हो जाएंगे। कृपया ध्यान दें कि प्रोजेक्ट, सभी चैट समूहों और डेटा के साथ, निष्क्रिय स्थिति में सुलभ रहेगा।",
  mark_not_done: "क्या आप वाकई प्रोजेक्ट को फिर से खोलना चाहते हैं? एक बार खुले के रूप में चिह्नित करने के बाद, अतिरिक्त सदस्य शामिल हो सकते हैं या जोड़े जा सकते हैं, और सभी चैट समूह पुनः सक्रिय हो जाएंगे।",
  mark_as_completed: "प्रोजेक्ट को पूर्ण के रूप में चिह्नित करें",
  room_completed: "प्रोजेक्ट पूर्ण",
  room_members: "प्रोजेक्ट के सदस्य",
  deactivated_rooms: "निष्क्रिय प्रोजेक्ट",
  deactivated_chats: "निष्क्रिय चैट",
  completed_rooms: "पूर्ण प्रोजेक्ट",
  request_to_join_a_room: 'प्रोजेक्ट में शामिल होने का अनुरोध',
  wants_to_rejoin_room: 'Username प्रोजेक्ट Roomname में फिर से शामिल होना चाहते हैं।',
  invited_you_to_join_room: 'Username ने आपको Roomname प्रोजेक्ट में शामिल होने के लिए आमंत्रित किया है।',
  restart: "पुनः आरंभ करें",
  update_text: "एक नया अपडेट उपलब्ध है। अपडेट स्थापित करने के लिए पुनः आरंभ पर क्लिक करें।",
  update_availble: "अपडेट उपलब्ध",
  Loading: "लोड हो रहा है...",
  logout: "लॉगआउट",
  back: 'वापस',
  company_list: "कंपनी सूची",
  followers: "अनुयायी",
  followings: "अनुसरण",
  article: "लेख",
  companies: "कंपनियां",
  one_to_one_chat: " एक से एक चैट",
  profile: "प्रोफ़ाइल",
  company: "कंपनी",
  company_selection: "कंपनी चयन",
  home: "होम",
  contact: "संपर्क ",
  add_company: "कंपनी जोड़ें ",
  add_project: "प्रोजेक्ट जोड़ें ",
  capacities: "क्षमताएं ",
  work_area: "कार्य क्षेत्र",
  company_services: "कंपनी सेवाएं",
  website: "वेबसाइट",
  search_contacts: "संपर्क खोजें",
  add_or_join_a_company: "कंपनी जोड़ें या शामिल हों",
  follow: "अनुसरण करें",
  following: "अनुसरण कर रहे हैं",
  like: "पसंद",
  company_contacts: "कंपनी संपर्क",
  leave_the_company: "कंपनी छोड़ें",
  news: "समाचार",
  earlier: "पहले",
  action: "कार्रवाई",
  another_action: "दूसरी कार्रवाई",
  something_else: "कुछ और",
  search: "खोजें",
  search_rooms: "प्रोजेक्ट खोजें",
  search_articles: "लेख खोजें",
  contacts: "संपर्क",
  suggestions: "सुझाव",
  project_list: "प्रोजेक्ट सूची",
  search_results: "खोज परिणाम",
  add_or_join_project: "प्रोजेक्ट जोड़ें या शामिल हों",
  details: "विवरण",
  your_position_within_company: "कृपया कंपनी के भीतर अपनी स्थिति चुनें।",
  close_modal: "बंद करें",
  map: "नक्शा",
  or: "या",
  name: "नाम*",
  street: "सड़क*",
  house_number: "मकान नंबर",
  postal_code: "पिन कोड",
  city: "शहर*",
  opened_by: "द्वारा खोला गया:",
  project_No: "प्रोजेक्ट-नं: ",
  building_type: "भवन प्रकार*",
  building_types: "भवन प्रकार",
  add_join: "जोड़ें/शामिल हों",
  mandatory_fiels: "*अनिवार्य फ़ील्ड",
  invalid_fiels: "यह फ़ील्ड आवश्यक है",
  add_or_join_company: "कंपनी जोड़ें या शामिल हों",
  name_of_the_company: "कंपनी का नाम",
  edit_company_details: "कंपनी विवरण संपादित करें",
  branch_of_the_building_industry: "निर्माण उद्योग की शाखा",
  corporate_form: "कॉर्पोरेट रूप",
  position_within_company: "कंपनी के भीतर स्थिति",
  request_confirmation: "लंबित प्रोजेक्ट के अनुरोध",
  company_e_mail: "कंपनी ई-मेल",
  type_of_filter: "फ़िल्टर करने के लिए टाइप करें...",
  setting: "सेटिंग",
  dashboard: "डैशबोर्ड",
  settings: "सेटिंग्स",
  views: "दृश्य",
  times_seen: "बार देखा गया",
  see_more: "...अधिक",
  see_less: "...कम",
  in_search: "खोज में",
  reset_password: "पासवर्ड रीसेट करें",
  submit: "सबमिट करें",
  password: "पासवर्ड",
  email: "ईमेल",
  confirm_password: "पासवर्ड की पुष्टि करें",
  reset_email: "ई-मेल रीसेट करें",
  update: "अपडेट करें",
  new_email: "नया ई-मेल",
  kjuup_message: "Kjuup संदेश",
  delete_profile: "प्रोफ़ाइल हटाएं?",
  my_position: "मेरी स्थिति:",
  add: "जोड़ें",
  owner_company_admin: "कंपनी व्यवस्थापक :",
  owner_company_admin_new: "कंपनी व्यवस्थापक",
  mutual_contact: "पारस्परिक संपर्क",
  mutual_contacts: "पारस्परिक संपर्क",
  co_owner: "सह-मालिक",
  managing_director: "प्रबंध निदेशक",
  associate: "सहयोगी",
  secretary: "सचिव",
  employee: "कर्मचारी",
  project_manage: "प्रोजेक्ट मैनेजर",
  auto_chat_translation: "स्वचालित चैट अनुवाद",
  translate_room_group_names: "चैट समूह नाम अनुवाद करें",
  translate_room_group_names_info: "सक्षम होने पर चैट समूह के नाम स्वचालित रूप से इंटरफ़ेस भाषा में अनुवादित होते हैं।",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "सक्षम होने पर, ऐप खोलने पर संदेशों के बजाय डिफ़ॉल्ट रूप से ई-मेल टैब खुलेगा।",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "भाषा",
  english: "अंग्रेजी",
  german: "जर्मन",
  french: "फ्रेंच",
  italian: "इतालवी",
  change_language: "भाषा बदलें",
  my_companies: "मेरी कंपनियां",
  employees: "कर्मचारी",
  invite_with_a: "Kjuup में आमंत्रित करें",
  add_member: "सदस्य जोड़ें",
  add_user: "उपयोगकर्ता जोड़ें",
  send_location: "स्थान भेजें",
  assign_admin_rights: "व्यवस्थापक अधिकार समायोजित करें",
  deactivate_company: "कंपनी निष्क्रिय करें",
  remove_employees: "कर्मचारियों को हटाएं",
  remove_members: "सदस्यों को हटाएं",
  no_user_found: "कोई उपयोगकर्ता नहीं मिला!",
  approve: "अनुमोदन करें!",
  deselect_all: "सभी अचयनित करें",
  select_all: "सभी चुनें",
  translation_on_building_projects: "प्रोजेक्टों में अनुवाद",
  reported_capacities: "रिपोर्ट की गई सेवाएं",
  up_to_50m_exact: "50 मीटर तक सटीक",
  company_details_service: "कंपनी सेवाएं",
  company_contact: "कंपनी संपर्क",
  invite_with_link: "Kjuup में आमंत्रित करें",
  share_link: "लिंक साझा करें",
  share_company_link: "लिंक साझा करें",
  qr_code: "QR कोड",
  copy_link: "लिंक कॉपी करें",
  cancel_link: "लिंक रद्द करें",
  who_has_confirmed_services: "किसने आपकी सेवाओं की पुष्टि की है?",
  projectss: "प्रोजेक्ट",
  add_services: "सेवाएं जोड़ें",
  services: "सेवाएं",
  save_text: "सहेजें",
  share_on: "साझा करें:",
  articlen: "लेख",
  invite_user_to_confirm_service: "कंपनी में सेवाओं की पुष्टि करने के लिए उपयोगकर्ताओं को आमंत्रित करें।",
  link_copied: "लिंक कॉपी किया गया!",
  email_copied: "ईमेल कॉपी किया गया!",
  personal_article: "व्यक्तिगत लेख",
  company_article: "कंपनी लेख",
  characters_remaining: "शेष वर्ण",
  optional_information: "वैकल्पिक जानकारी",
  project: "प्रोजेक्ट",
  projects: "प्रोजेक्ट...",
  abort: "त्यागें",
  preview: "पूर्वावलोकन",
  post: "पोस्ट करें",
  of: "का",
  remove: "हटाएं",
  free_capacity: "नौकरी पोर्टल",
  current_status_overview: "वर्तमान स्थिति अवलोकन",
  report_capacities: "सेवाएं रिपोर्ट करें",
  report_text: "रिपोर्ट",
  search_capacities: "ठेकेदार खोजें",
  add_project_user: "प्रोजेक्ट उपयोगकर्ता जोड़ें",
  media: "मीडिया",
  links: "लिंक",
  docs: "दस्तावेज़",
  featured_products: "विशेष उत्पाद...",
  title: "शीर्षक",
  text: "पाठ",
  feed_details: "फ़ीड विवरण",
  add_employee: "कर्मचारी जोड़ें",
  latest: "नवीनतम",
  my_projects: "मेरे प्रोजेक्ट",
  cancel: "रद्द करें",
  continue: "जारी रखें",
  role_in_the_building_industry: "निर्माण उद्योग में भूमिका",
  als: "के रूप में",
  join: "शामिल हों",
  find: "खोजें",
  request_to_join_a_company: "कंपनी में शामिल होने का अनुरोध",
  wants_to_join_the_company: "कंपनी में शामिल होना चाहता है",
  filter_by: "द्वारा फ़िल्टर करें",
  ok: "ठीक",
  close: "बंद करें",
  weekly_statistics: "साप्ताहिक आंकड़े",
  is_following_you: "आपका अनुसरण कर रहा है।",
  as: "के रूप में",
  has_joined_the: "कंपनी में शामिल हो गया है",
  has_looked_at_your_profile: "ने आपकी प्रोफ़ाइल देखी है।",
  time: "समय",
  in_searches_in_past_week: "पिछले सप्ताह में खोजों में।",
  has_liked_your_article: "ने आपके लेख को पसंद किया है।",
  has_published_a_new_article: "ने एक नया लेख प्रकाशित किया है।",
  you: "आप",
  all_views: "सभी दृश्य",
  all_profile_views: "सभी प्रोफ़ाइल दृश्य",
  mutual_company: "पारस्परिक कंपनी",
  artical_text: "लेख लिखें...",
  you_have_appeared: "आप दिखाई दिए हैं",
  your_request_at_the_company: "कंपनी में आपका अनुरोध",
  times_you_have_appeared_in_searches: "बार आप खोजों में दिखाई दिए हैं",
  appear_more_often_in_searches: "खोजों में अधिक बार दिखाई दें",
  you_have_been_found: "आपको खोजा गया है",
  improve_profile: "प्रोफ़ाइल सुधारें",
  choose_existing_contact_for_single_chat: "एकल चैट के लिए मौजूदा संपर्क चुनें:",
  in_order_to_add_new_contacts: "नए संपर्क जोड़ने के लिए कृपया प्रोफ़ाइल पृष्ठ पर नए संपर्क खोजें।",
  times_in_searches_in_the_last_week: "पिछले सप्ताह में खोजों में बार। अपने प्रोफ़ाइल को अपडेट करें और अधिक आसानी से खोजे जाने के लिए अतिरिक्त विवरण जोड़ें।",
  has_been_confirmed: "की पुष्टि की गई है।",
  have_joined_the: "शामिल हो गए हैं ",
  building_project: " निर्माण प्रोजेक्ट।",
  select_with_which_company_you_want_to_connect_to_the_project: "वह कंपनी चुनें जिसका आप प्रतिनिधित्व करेंगे। यह अन्य प्रतिभागियों को दिखाई देगा।",
  select_with_which_company_you_want_to_connect_to_the_chat: "वह कंपनी चुनें जिसका आप प्रतिनिधित्व करेंगे। यह अन्य प्रतिभागियों को दिखाई देगा।",
  select_internal_section: "कृपया आंतरिक अनुभाग चुनें",
  select_profile_image: "प्रोफ़ाइल छवि चुनें",
  share_user: "उपयोगकर्ता साझा करें",
  contact_sender_message: "Kjuup के गैर-सदस्य को Kjuup में आमंत्रित करने के लिए इस लिंक को साझा करें। इस लिंक का उपयोग कई लोग पंजीकरण के लिए कर सकते हैं।",
  project_sender_message: "Kjuup के गैर-सदस्य को प्रोजेक्ट नाम में आमंत्रित करने के लिए इस लिंक को साझा करें। इस लिंक का उपयोग कई लोग पंजीकरण करने और Kjuup में प्रोजेक्ट नाम में शामिल होने के लिए कर सकते हैं।",
  company_sender_message: "Kjuup के गैर-सदस्य को कंपनी कंपनी नाम में आमंत्रित करने के लिए इस लिंक को साझा करें। इस लिंक का उपयोग कई लोग पंजीकरण करने और Kjuup में कंपनी में शामिल होने के लिए कर सकते हैं।",
  contact_receivers_message: "Kjuup में शामिल होने के लिए आमंत्रण लिंक। कृपया kjuup के लिए पंजीकरण करने के लिए लिंक पर क्लिक करें।",
  iphone: "iPhone:",
  iphone_recivers_message: "यदि आप Apple App Store के माध्यम से Kjuup स्थापित कर रहे हैं, तो पंजीकरण करने में सक्षम होने के लिए सफल डाउनलोड के बाद आपको इस लिंक पर क्लिक करना होगा।",
  project_receivers_message: "Kjuup में प्रोजेक्ट नाम में शामिल होने के लिए आमंत्रण लिंक। कृपया Kjuup के लिए पंजीकरण करने और प्रोजेक्ट नाम में शामिल होने के लिए लिंक पर क्लिक करें।",
  company_receivers_message: "Kjuup में कंपनी कंपनी नाम के लिए आमंत्रण लिंक। कृपया Kjuup के लिए पंजीकरण करने और कंपनी कंपनी नाम में शामिल होने के लिए लिंक पर क्लिक करें।",
  sign_in: "साइन इन करें",
  enter_your_email_add: "अपना ईमेल पता दर्ज करें",
  forgot_password: "पासवर्ड भूल गए",
  dont_have_account: "खाता नहीं है?",
  register: "पंजीकरण करें",
  get_app: "ऐप प्राप्त करें",
  registration: "पंजीकरण",
  dep_ing: "Dipl.-Ing.",
  dr: "डॉ.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "प्रोफेसर",
  first_name: "पहला नाम",
  last_name: "अंतिम नाम",
  have_an_account: "खाता है?",
  when_register_you_agree: "पंजीकरण करते समय आप हमारी सहमति देते हैं",
  term_of_use: "उपयोग की शर्तें",
  to: "को।",
  in_our: "हमारे",
  data_policy: "डेटा नीतियां",
  they_find_out: "वे पता लगाते हैं,",
  we_provide_store_data: "हम कैसे जानकारी एकत्र, प्रसंस्करण और संग्रहीत करते हैं।",
  leaving_company_text: "क्या आप वाकई कंपनी छोड़ना चाहते हैं? कंपनी छोड़ते समय आप सभी संबद्ध प्रोजेक्टों और चैट समूहों को भी छोड़ देते हैं। आप किसी भी समय किसी अन्य कंपनी के साथ इन प्रोजेक्टों में फिर से शामिल हो सकते हैं।",
  delete_profile_text: "क्या आप वाकई अपनी प्रोफ़ाइल हटाना चाहते हैं? जब आप अपनी प्रोफ़ाइल हटाते हैं तो कंपनियों, प्रोजेक्ट और चैट से सभी कनेक्शन हटा दिए जाएंगे। आप किसी भी समय एक नई प्रोफ़ाइल बना सकते हैं।",
  confirm: "पुष्टि करें",
  reject: "अस्वीकार करें",
  requet_to_leave: "छोड़ने का अनुरोध",
  choose: "चुनें",
  your_add_member: "सदस्य जोड़ें",
  if_you: "यदि आप",
  can_not_find: "यहां अपना संपर्क नहीं मिल सकता।",
  please_wait: "कृपया प्रतीक्षा करें..",
  imprint_gtc: "इम्प्रिंट/GTC",
  register_confirm_popup: "लॉग इन करने से पहले अपना Kjuup ईमेल सत्यापित करें। हमने आपके इनबॉक्स में एक पुष्टि लिंक भेजा है। यदि दिखाई न दे तो स्पैम फ़ोल्डर भी जाँचें।",
  PENDING_GROUP_USER: "प्रोजेक्ट में आमंत्रण की पुष्टि होने के बाद ही संदेश प्राप्त करेगा। प्रोजेक्ट में आमंत्रण की पुष्टि होने के बाद एक अतिरिक्त संदेश दिखाई देगा।",
  PENDING: "प्रोजेक्ट में आमंत्रण की पुष्टि लंबित",
  denied_group_chat: " ने प्रोजेक्ट के आमंत्रण को अस्वीकार कर दिया है और इस समूह को छोड़ दिया है।",
  joined_group_chat: " इस समूह में शामिल हो गया",
  you_joined_group_chat: "आप इस समूह में शामिल हो गए।",
  Others: "अन्य",
  LEFT_GROUP: "ने इस चैट समूह को छोड़ दिया है।",
  YOU_LEFT_GROUP: "ने इस चैट समूह को छोड़ दिया है।",
  days: "दिन",
  day: "दिन",
  hour: "घंटा",
  hide_project: "प्रोजेक्ट छुपाएं",
  hide_project_popup_text: "यदि आप प्रोजेक्ट छुपाते हैं, तो उन्हें Kjuup के भीतर नहीं खोजा जा सकता। केवल प्रोजेक्ट के सदस्य ही नए उपयोगकर्ताओं को प्रोजेक्ट में आमंत्रित कर सकते हैं।",
  branch: "शाखा",
  photo_video_media_lib: "फोटो - वीडियो मीडिया लाइब्रेरी",
  document: "दस्तावेज़",
  location_meeting: "स्थान / बैठक",
  all_member_of_project: "प्रोजेक्ट के सभी सदस्य",
  pending_request: "लंबित प्रोजेक्ट के अनुरोध",
  no_pending_request: "कोई लंबित अनुरोध नहीं मिला!",
  news_feed: "समाचार-फ़ीड",
  user_info: "समूह जानकारी",
  leave_project: "प्रोजेक्ट छोड़ें",
  media_link_docs: "फ़ाइलें",
  search_chat: "चैट खोजें",
  export_chat_group: "पिछले महीने से चैट समूह डेटा निर्यात करें",
  request_complete_chat_history: "पूर्ण चैट इतिहास का अनुरोध करें",
  leave_chat_group: "चैट समूह छोड़ें",
  add_user_project: "उपयोगकर्ता जोड़ें",
  me: "मैं",
  max_open_one_to_one: "वर्तमान में अधिकतम 2 एक-से-एक चैट नीचे - और ऊपरी अनुभाग में समानांतर में खोले जा सकते हैं। कुल मिलाकर अधिकतम 4 एक-से-एक चैट संभव हैं।",
  are_you_sure_you_want_leave_chat: "क्या आप वाकई इस चैट समूह को छोड़ना चाहते हैं?",
  create_group: "समूह बनाएं",
  adding_members: "सदस्य जोड़े जा रहे हैं...",
  creating_the_chat: "चैट बनाई जा रही है...",
  finishing_setup: "सेटअप पूरा हो रहा है...",
  group_name: "समूह नाम",
  by: "द्वारा:",
  mandetory: "*अनिवार्य",
  delteed: "ने अपनी प्रोफ़ाइल हटा दी है और समूह चैट छोड़ दी है।",
  deleted_direct: "ने अपनी प्रोफ़ाइल हटा दी है और चैट छोड़ दी है।",
  unhidden_message: "यदि आप प्रोजेक्ट को अनहाइड करते हैं, तो उन्हें Kjuup के सभी सदस्यों द्वारा खोजा जा सकता है।",
  account_deleted: "खाता हटा दिया गया है।",
  refuse_company: "क्या आप वाकई कंपनी आमंत्रण को अस्वीकार करना चाहते हैं?",
  follow_additional: "अतिरिक्त उपयोगकर्ताओं का अनुसरण करें",
  f_add: "प्रत्यक्ष संदेशों के लिए उन्हें उपलब्ध बनाने के लिए Kjuup के अतिरिक्त उपयोगकर्ताओं का अनुसरण करें।",
  c_inv: "कंपनी आमंत्रण",
  invited_o_Company: "आपको कंपनी में शामिल होने के लिए आमंत्रित किया गया है",
  refuse_companyX: "क्या आप वाकई कंपनी अनुरोध को अस्वीकार करना चाहते हैं?",
  a_Da: "खाता निष्क्रिय।",
  has_deactivated: "ने अपनी प्रोफ़ाइल निष्क्रिय कर दी है।",
  reactive: "ने अपनी प्रोफ़ाइल पुनः सक्रिय कर दी है।",
  juup_note: "*उपयोगकर्ता नाम के साथ पंजीकरण केवल Kjuup+ सदस्यों के लिए उपलब्ध है",
  username: "उपयोगकर्ता नाम*",
  email_username: "ईमेल/उपयोगकर्ता नाम*",
  sPinText: "कृपया 6-अंकीय सुरक्षा पिन प्रदान करें। यह पिन आवश्यक होगा यदि आप अपना पासवर्ड भूल जाते हैं और आपके खाते की पुष्टि करने के लिए अनिवार्य है।",
  DeleteKjuupPlusText: "क्या आप वाकई अपनी प्रोफ़ाइल हटाना चाहते हैं? जब आप अपनी प्रोफ़ाइल हटाते हैं तो कंपनियों, प्रोजेक्ट और चैट से सभी कनेक्शन हटा दिए जाएंगे।\n\nखाता हटाने के 48 घंटे बाद आप उपयोगकर्ता नाम, पासवर्ड और पिन के साथ साइन इन करके अपने खाते को पुनः सक्रिय कर सकते हैं।",
  reactive_text: "आपका खाता हटा दिया गया है। कृपया अपने खाते को पुनः सक्रिय करने के लिए पुनः सक्रिय करें पर क्लिक करें।",
  rac: "पुनः सक्रिय करें",
  ac_ss: "खाता सफलतापूर्वक पुनः सक्रिय हो गया।",
  not_valid_pin: "पिन अमान्य",
  only_for_kjuup: "*उपयोगकर्ता नाम और पिन के माध्यम से पासवर्ड रीसेट केवल Kjuup+ सदस्यों के लिए उपलब्ध है।",
  resetPIN: "PIN रीसेट करें",
  enter_current_pin: "कृपया अपना वर्तमान PIN दर्ज करें",
  enter_new: "नया PIN दर्ज करें",
  pin_to_confirm: "कृपया पुष्टि करने के लिए PIN प्रदान करें।",
  change_username: "उपयोगकर्ता नाम रीसेट करें",
  pp_not_match: "पासवर्ड - और पुष्टि पासवर्ड मेल नहीं खाते",
  reactive_itself: "आपने अपनी प्रोफ़ाइल पुनः सक्रिय कर दी है।",
  has_deactivated_itself: "आपने अपनी प्रोफ़ाइल निष्क्रिय कर दी है।",
  more_than_two: "वर्तमान में प्रत्यक्ष संदेश केवल 2 उपयोगकर्ताओं के साथ समानांतर में किए जा सकते हैं।",
  Chats: "प्रत्यक्ष संदेश",
  only_in_mobileL: "मूल वीडियो वर्तमान में केवल मोबाइल ऐप के माध्यम से अपलोड और पोस्ट किए जा सकते हैं। कृपया Youtube और Vimeo के वीडियो लिंक का उपयोग करें।",
  register_pin_text: "कृपया अपना व्यक्तिगत 6-अंकीय PIN चुनें। यह PIN खाता रीसेट कार्यक्षमताओं को सक्षम करने के लिए आवश्यक होगा।",
  internal_project: "आंतरिक",
  external_projects: "बाहरी",
  in_deacticted: "आंतरिक अनुभाग निष्क्रिय है।",
  create_article: "लेख बनाएं",
  new_article_selection: "बाहरी समाचार-फ़ीड के लिए लेख बनाएं",
  new_article_selection_internal: "आंतरिक लेख बनाएं",
  active_trans_title: "स्वचालित अनुवाद चालू करें?",
  active_trans: "सक्षम होने पर, सभी आने वाले चैट संदेश आपकी चयनित ऐप भाषा में अनुवादित हो जाएंगे।",
  disable_trans: "क्या आप वाकई स्वचालित अनुवाद निष्क्रिय करना चाहते हैं?",
  allow_access_chat: "पूर्ण चैट इतिहास दिखाएं",
  toggle_chat_history_on: "क्या आप वाकई चाहते हैं कि उपयोगकर्ता पूर्ण चैट इतिहास देखे?",
  toggle_chat_history_off: "क्या आप वाकई चाहते हैं कि उपयोगकर्ता केवल चैट में शामिल होने के बिंदु से चैट इतिहास देखे?",
  check_selected_settings: "कृपया सभी चयनित उपयोगकर्ताओं के लिए चैट इतिहास की सेटिंग्स जांचें!",
  chat_from_start_have: "आप इस समूह में शामिल हो गए हैं। चैट इतिहास साझा किया गया है।",
  chat_from_start_has: "इस समूह में शामिल हो गया है। चैट इतिहास साझा किया गया है।",
  Address: "पता",
  read_by: "द्वारा पढ़ा गया",
  deliver_to: "को वितरित",
  remaining: "शेष",
  message_info: "संदेश जानकारी",
  request_to_join_only: "शामिल होने का अनुरोध",
  unfollow: "अनुसरण न करें",
  company_username: "उपयोगकर्ता नाम",
  month: ["जनवरी", "फरवरी", "मार्च", "अप्रैल", "मई", "जून", "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"],
  remove_my_admin_right: "मेरे व्यवस्थापक अधिकार हटाएं",
  makeEmp: "क्या आप वाकई उपयोगकर्ता से कंपनी व्यवस्थापक अधिकार हटाना चाहते हैं?",
  remove_my_self: "क्या आप वाकई अपने खाते से कंपनी व्यवस्थापक अधिकार हटाना चाहते हैं?",
  makeAdmin: "क्या आप वाकई उपयोगकर्ता को कंपनी व्यवस्थापक अधिकार देना चाहते हैं?",
  remove_member: "सदस्य हटाएं",
  remove_following_confirm: "क्या आप वाकई {name} को फॉलो की सूची से हटाना चाहते हैं?",
  remove_follower_confirm: "क्या आप वाकई {name} को अपने फॉलोअर्स से हटाना चाहते हैं? हटाने पर उन्हें सूचित नहीं किया जाएगा।",
  do_you_really_want_to_remove: "क्या आप वाकई कंपनी से उपयोगकर्ता नाम हटाना चाहते हैं?",
  invite_all: "कंपनी के सभी सदस्यों को आमंत्रित करें",
  invite_all_members: "सभी सदस्यों को आमंत्रित करें",
  mems: "सभी अन्य सदस्य",
  dep_loc: "विभाग/स्थान/टीम",
  depAdmin: "विभाग व्यवस्थापक",
  add_remove_admin: "कंपनी व्यवस्थापक पद जोड़ें/हटाएं",
  add_remove_dep_admin: "विभाग व्यवस्थापक पद जोड़ें/हटाएं",
  remove_employees_dept: "से कर्मचारियों को हटाएं",
  want_to_join_dep: "उपयोगकर्ता नाम कंपनी कंपनी नाम के विभाग/स्थान/टीम depname में शामिल होना चाहता है।",
  you_invited: "आपको कंपनी कंपनी नाम के विभाग/स्थान/टीम depname में शामिल होने के लिए आमंत्रित किया गया है।",
  dep_remove: "क्या आप वाकई उपयोगकर्ता से विभाग या स्थान के लिए व्यवस्थापक अधिकार हटाना चाहते हैं?",
  add_dep: "क्या आप वाकई उपयोगकर्ता को विभाग या स्थान के लिए व्यवस्थापक अधिकार देना चाहते हैं?",
  my_self_dep_remove: "क्या आप वाकई अपने खाते से विभाग व्यवस्थापक अधिकार हटाना चाहते हैं?",
  member: "सदस्य",
  admin: "व्यवस्थापक",
  remove_project_admin: "क्या आप वाकई प्रोजेक्ट से सदस्य को हटाना चाहते हैं?",
  remove_my_self_project: "क्या आप वाकई व्यवस्थापक अधिकार हटाना चाहते हैं?",
  remove_member_admin_right: "क्या आप वाकई उपयोगकर्ता से व्यवस्थापक अधिकार हटाना चाहते हैं?",
  add_member_admin_right: "क्या आप वाकई उपयोगकर्ता को व्यवस्थापक अधिकार जोड़ना चाहते हैं?",
  add_remove_Poss: "व्यवस्थापक पद जोड़ें/हटाएं",
  forward: "अग्रेषित करें",
  edit: "संपादित करें",
  only_kjuup_plus_can: "केवल Kjuup+ कंपनियां लेख पोस्ट कर सकती हैं।",
  add_images: "छवि(यां) जोड़ें",
  request_confirmation: 'लंबित प्रोजेक्ट के आमंत्रण',
  Activity: "गतिविधि",
  latest_messages: "नवीनतम संदेश",
  hours: "घंटे",
  minute: "मिनट",
  seconds: "सेकंड",
  days: "दिन",
  yesterday: "कल",
  last_week: "पिछला सप्ताह",
  next_week: "अगला सप्ताह",
  Last_month: "पिछला महीना",
  All: "सभी",
  register_plus: "पंजीकरण प्लस",
  select_files: "फ़ाइलें चुनें",
  monthsFullName: ["जनवरी", "फरवरी", "मार्च", "अप्रैल", "मई", "जून", "जुलाई", "अगस्त", "सितंबर", "अक्टूबर", "नवंबर", "दिसंबर"],
  company_deploc_receivers_message: "Kjuup में कंपनी कंपनी नाम के विभाग के लिए आमंत्रण लिंक। कृपया Kjuup के लिए पंजीकरण करने और कंपनी कंपनी नाम में शामिल होने के लिए लिंक पर क्लिक करें।",
  no_news: "कोई समाचार उपलब्ध नहीं",
  reminder: "अनुस्मारक",
  np_reminder: "कोई ToDo नहीं",
  move_to_reminder: "ToDo में ले जाएं",
  remove_reminder: "क्या आप वाकई इस संदेश को अपनी ToDo की सूची से हटाना चाहते हैं?",
  remove_all_reminder: "सभी ToDo हटाएं",
  remove_all_confirm: "क्या आप वाकई सभी संदेशों को अपनी ToDo की सूची से हटाना चाहते हैं?",
  remove_from_reminder: "अनुस्मारक से हटाएं",
  prevent_email: "ई-मेल का उपयोग उपयोगकर्ता नाम के रूप में नहीं किया जा सकता।",
  allow_noti: "कृपया सूचनाएं अनुमति दें।",
  join_cap: "शामिल हों",
  pass_minimum: "**पासवर्ड में 12 वर्ण शामिल होने चाहिए जिसमें छोटे -, बड़े अक्षर, संख्या और विशेष वर्ण शामिल हों।",
  pass_error: "कृपया पासवर्ड आवश्यकताओं की जांच करें",
  people_that_like_article: "वे लोग जो लेख को पसंद करते हैं।",
  people_who_like_article: "वे लोग जो आपके लेख को पसंद करते हैं।",
  message_delete: "यह संदेश हटा दिया गया है।",
  message_edited: "संपादित",
  edit_message: "संदेश संपादित करें",
  edit_window_expired: "संदेश केवल भेजने के 10 मिनट के भीतर संपादित किए जा सकते हैं।",
  message_edit_save: "सहेजें",
  copy: "कॉपी करें",
  bookmark: "बुकमार्क",
  add_reaction: "प्रतिक्रिया जोड़ें",
  delete_message: "संदेश हटाएं",
  more_options: "और विकल्प",
  info: "जानकारी",
  link_invite: "लिंक के माध्यम से आमंत्रित करें",
  ll_nkk: "Kjuup में आमंत्रित करें",
  selected: "चयनित",
  is_active: "सक्रिय",
  inactive: "निष्क्रिय",
  last_online: "अंतिम बार ऑनलाइन {{when}}",
  remove_user_l: "हटाएं",
  link_expire: "प्रत्येक उत्पन्न लिंक 72 घंटे के लिए वैध होगा।",
  company_language: "कंपनी भाषा",
  company_language_info: "भाषा चयन का उपयोग कंपनी से संबंधित सभी ईमेल पुष्टि के लिए किया जाएगा।",
  s_image: "छवि",
  m_image: "छवियां",
  removeMsg: "हटाने के लिए टैप करें",
  block: 'ब्लॉक करें',
  unblock: 'अनब्लॉक करें',
  blocks: 'क्या आप वाकई इस उपयोगकर्ता को ब्लॉक करना चाहते हैं?',
  unblocks: 'क्या आप वाकई इस उपयोगकर्ता को अनब्लॉक करना चाहते हैं?',
  bolcked_click_un_block: 'आपने इस संपर्क को ब्लॉक कर दिया है। ब्लॉकिंग हटाने के लिए यहां क्लिक करें।',
  you_have_unblocked: 'आपने इस संपर्क को अनब्लॉक कर दिया है।',
  you_have_blocked: 'आपने इस संपर्क को ब्लॉक कर दिया है।',
  unblock_to_send: 'संदेश भेजने के लिए उपयोगकर्ता को अनब्लॉक करें।',
  pilot_text: "निर्माण विषयों के लिए विशेष AI",
  startup_screen_label: "स्टार्ट स्क्रीन",
  startup_screen_info: "Kjuup शुरू होने पर कौन सी स्क्रीन खुले, चुनें।",
  startup_screen_feed: "Home",
  startup_screen_messages: "संदेश",
  startup_screen_saved: "स्टार्ट स्क्रीन अपडेट की गई",
email_on: "ईमेल सूचना चैट",
  email_on_grp: "ईमेल सूचना",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "इस प्रोजेक्ट के लिए ईमेल सूचनाएं सक्रिय या निष्क्रिय करें। यह विकल्प केवल तभी उपलब्ध है जब \"ईमेल सूचना चैट\" व्यक्तिगत सेटिंग्स के माध्यम से सक्षम हो।",
  todo_notification_info: "जब भी आपको कोई नया कार्य सौंपा जाएगा, आपको सूचित किया जाएगा।",
  info_val: "यदि कोई नया चैट संदेश थोड़े समय में नहीं पढ़ा जाता है, तो आपको एक ईमेल मिलेगा। आप इसे विशिष्ट प्रोजेक्टों या चैट के लिए उनकी सेटिंग्स में या चैट समूह जानकारी में बंद कर सकते हैं।",
  email_groups: "इस चैट के लिए ईमेल सूचनाएं सक्रिय या निष्क्रिय करें। यह विकल्प केवल तभी उपलब्ध है जब \"ईमेल सूचना चैट\" व्यक्तिगत- और प्रोजेक्ट की सेटिंग्स के माध्यम से सक्षम हो।",
  add_update_email: "ईमेल जोड़ें/अपडेट करें",
  text_to_verifiy: "\"ईमेल सूचना चैट\" विकल्प केवल तभी सक्षम किया जा सकता है जब आपके पास फ़ाइल पर एक सत्यापित ईमेल पता हो।",
  stored_email: "संग्रहीत ईमेल: ",
  verify_email: "पुष्टि लंबित!",
  join_call: "शामिल हों",
  call_is_started: "कॉल शुरू हो गया",
  start_chat: "प्रत्यक्ष-चैट शुरू करें?",
  project_rooms: "प्रोजेक्ट",
  download_selected: "डाउनलोड",
  add_employee_confirm: 'क्या आप वाकई इस उपयोगकर्ता को कंपनी में जोड़ना चाहते हैं?',
  invalid_deeplink: "अमान्य deeplink URL। आवश्यक पैरामीटर गुम हैं।",
  deeplink_error: "Deeplink को संसाधित करने में असमर्थ। कृपया बाद में पुनः प्रयास करें।",
  reply: "उत्तर दें",
  reply_enter: "उत्तर दर्ज करें...",
  reply_sent_successfully: "उत्तर सफलतापूर्वक भेजा गया",
  reply_failed: "उत्तर भेजने में विफल",
  reply_failed_generic: "उत्तर भेजने में विफल। कृपया पुनः प्रयास करें।",
  replying_to_message: "संदेश का उत्तर दे रहे हैं",
  cancel_reply: "उत्तर रद्द करें",
  voice_message: "आवाज़ संदेश",
  send: "भेजें",
  cancel: "रद्द करें",
  type_your_reply: "अपना उत्तर टाइप करें...",
  suggested_replies: "सुझाए गए उत्तर",
  suggestions_error: "सुझाव लोड करने में विफल",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "एक क्षण। आपका पाठ व्यक्तिगत रूप से आपके लिए तैयार किया जा रहा है।",
  loading_chat_message: "चैट लोड हो रही है...",
  extracting_message: "संदेश निकाला जा रहा है...",
  create_todo: "ToDo बनाएं",
  create_todo_confirmation: "क्या आप इस संदेश से ToDo बनाना चाहते हैं?",
  select_project_required: "कृपया एक प्रोजेक्ट/समूह चुनें",
  only_assigned_can_change_status: "केवल असाइन किए गए उपयोगकर्ता स्थिति बदल सकते हैं",
  todo_summary: "सारांश",
  todo_summary_placeholder: "todo सारांश दर्ज करें...",
  todo_date: "तारीख",
  todo_time: "समय",
  todo_date_hint: "मूल संदेश तारीख/समय का उपयोग करने के लिए खाली छोड़ें",
  todo_created_success: "ToDo सफलतापूर्वक बनाया गया",
  todo_creation_failed: "ToDo बनाने में विफल",
  create: "बनाएं",
  image: "छवि",
  images: "छवियां",
  remove_all_images: "सभी छवियां हटाएं",
  remove_image: "छवि हटाएं",
  remove_document: "दस्तावेज़ हटाएं",
  remove_recording: "रिकॉर्डिंग हटाएं",
  play_recording: "रिकॉर्डिंग चलाएं",
  upload_image: "छवि अपलोड करें",
  upload_document: "दस्तावेज़ अपलोड करें",
  record_audio: "ऑडियो रिकॉर्ड करें",
  stop_recording: "रिकॉर्डिंग रोकें",
  stop_recording_text: "रिकॉर्डिंग रोकें",
  please_remove_current_attachment: "कृपया वर्तमान अनुलग्नक हटाएं",
  please_upload_image_file: "कृपया एक वैध छवि फ़ाइल अपलोड करें",
  please_upload_valid_document: "कृपया एक वैध दस्तावेज़ फ़ाइल अपलोड करें",
  searching_messages: "संदेश खोज रहे हैं...",
  loading_more: "अधिक लोड हो रहा है...",
  loading_more_users: "अधिक उपयोगकर्ता लोड हो रहे हैं...",
  load_more_users: "अधिक उपयोगकर्ता लोड करें",
  no_more_users_to_load: "लोड करने के लिए कोई और उपयोगकर्ता नहीं",
  no_messages_found: "कोई संदेश नहीं मिला",
  try_different_keyword: "एक अलग कीवर्ड आज़माएं या अपनी वर्तनी जांचें।",
  search_messages: "संदेश, चैट समूह, प्रोजेक्ट और उपयोगकर्ता खोजें...",
  todo: "ToDo",
  np_todo: "कोई ToDo नहीं",
  move_to_todo: "ToDo के रूप में सहेजें",
  remove_todo: "क्या आप वाकई ToDo हटाना चाहते हैं?",
  remove_all_todo: "सभी ToDo हटाएं",
  remove_all_todo_confirm: "क्या आप वाकई सभी ToDo हटाना चाहते हैं?",
  add_to_todo: "ToDo में जोड़ें",
  remove_from_todo: "ToDo से हटाएं",
  confirm: "पुष्टि करें",
  ok: "ठीक",
  read_more: "अधिक पढ़ें",
  show_less: "कम दिखाएं",
  show_more: "और दिखाएं",
  audio: "ऑडियो",
  video: "वीडियो",
  notification_schedule: "सूचना अनुसूची",
  notification_schedule_desc: "आपको केवल आपके चुने हुए घंटों में पुश और ईमेल सूचनाएं मिलेंगी। उन समयों के बाहर वे रोक दी जाएंगी।",
  learn_more: "अधिक जानें",
  allow_notifications: "सूचनाएं अनुमति दें:",
  every_day: "प्रतिदिन",
  weekdays: "सप्ताह के दिन (सोमवार से शुक्रवार)",
  custom: "कस्टम",
  monday: "सोमवार",
  tuesday: "मंगलवार",
  wednesday: "बुधवार",
  thursday: "गुरुवार",
  friday: "शुक्रवार",
  saturday: "शनिवार",
  sunday: "रविवार",
  to: "को",
  notification_settings: "सूचनाएं",
  notification_settings_saved: "सूचना सेटिंग्स सफलतापूर्वक सहेजी गईं",
  notification_settings_error: "सूचना सेटिंग्स सहेजने में विफल",
  unavailability_note: "अनुपलब्धता नोट",
  unavailability_description: "आउट-ऑफ-ऑफिस नोट सेट करें। सक्रिय रहने पर, यह नोट आपकी सभी चैट में दूसरों को दिखाया जाता है और सूचनाएं रोक दी जाती हैं।",
  unavailability_start_date: "प्रारंभ तिथि",
  unavailability_end_date: "समाप्ति तिथि",
  unavailability_message: "संदेश",
  unavailability_message_hint: "अपनी वापसी की तारीख के लिए {endDate} को प्लेसहोल्डर के रूप में उपयोग करें।",
  unavailability_replacement: "प्रतिस्थापन संपर्क",
  unavailability_replacement_placeholder: "तत्काल अनुरोधों के लिए उपयोगकर्ता आईडी दर्ज करें",
  unavailability_replacement_current: "वर्तमान प्रतिस्थापन",
  unavailability_replacement_hint: "यदि सेट किया गया है, तो तत्काल मामलों के लिए इस व्यक्ति से संपर्क करने का लिंक आपके अनुपलब्धता नोट में दिखाया जाएगा।",
  unavailability_replacement_none: "कोई प्रतिस्थापन नहीं (वैकल्पिक)",
  unavailability_contact_urgent: "तत्काल अनुरोधों के लिए संपर्क करें",
  unavailability_default_message: "मैं वर्तमान में कार्यालय में नहीं हूँ और Kjuup तक मेरी पहुँच नहीं है। मैं {endDate} से फिर से उपलब्ध होऊंगा/होऊंगी और तब आपसे संपर्क करूंगा/करूंगी।",
  unavailability_save: "सहेजें",
  unavailability_deactivate: "निष्क्रिय करें",
  unavailability_active_until: "तक सक्रिय",
  unavailability_saved: "अनुपलब्धता नोट सहेजा गया",
  unavailability_save_error: "अनुपलब्धता नोट सहेजने में विफल",
  unavailability_deactivated: "अनुपलब्धता नोट निष्क्रिय किया गया",
  unavailability_end_date_required: "समाप्ति तिथि आवश्यक है",
  start_time_before_end_time: "समाप्ति समय से पहले प्रारंभ समय होना चाहिए",
  loading: "लोड हो रहा है",
  disabled: "अक्षम",
  enable: "सक्षम करें",
  disable: "अक्षम करें",
  forwarded: "अग्रेषित",
  message_forwarded: "संदेश अग्रेषित!",
  schedule_article_post: "लेख पोस्ट अनुसूचित करें",
  date: "तारीख",
  time: "समय",
  scheduled_for_publication: "प्रकाशन के लिए अनुसूचित",
  article_will_be_published_on: "लेख प्रकाशित होगा:",
  reset_selection: "चयन रीसेट करें",
  continue: "जारी रखें",
  cancel: "रद्द करें",
  error_loading_members: "सदस्य लोड करने में त्रुटि",
  please_fill_all_fields: "कृपया सभी फ़ील्ड भरें",
  invalid_email: "अमान्य ईमेल पता",
  member_added_successfully: "सदस्य सफलतापूर्वक जोड़ा गया",
  error_onboarding_user: "उपयोगकर्ता जोड़ने में त्रुटि",
  error_creating_chat: "चैट बनाने में त्रुटि",
  error_creating_group: "समूह बनाने में त्रुटि",
  new_group: "नया समूह",
  please_select_or_enter_group_name: "कृपया एक समूह चुनें या समूह नाम दर्ज करें",
  please_select_or_enter_room_name: "कृपया एक प्रोजेक्ट चुनें या प्रोजेक्ट नाम दर्ज करें",
  error_creating_room: "प्रोजेक्ट बनाने में त्रुटि",
  error_opening_chat: "चैट खोलने में त्रुटि",
  privacy_modal_text: "\"निजी\" का चयन केवल तभी करें यदि चैट में प्रोजेक्ट मैनेजर के लिए कोई प्रासंगिक पेशेवर सामग्री नहीं है।",
  not_private: "निजी नहीं",
  private: "निजी",
  error_loading_groups: "समूह लोड करने में त्रुटि",
  automatic_chat_export: "स्वचालित चैट निर्यात",
  automatic_chat_export_info: "सक्रियता के बाद, चैट इतिहास हर महीने स्वचालित रूप से निर्दिष्ट ईमेल पते पर भेजा जाएगा।",
  automatic_chat_export_no_email: "स्वचालित चैट निर्यात सक्रिय करने के लिए, आपको पहले एक ईमेल पता जोड़ना होगा। आप अपना ईमेल पता व्यक्तिगत सेटिंग्स में जोड़ सकते हैं।",
  enter_email: "ई-मेल दर्ज करें",
  update: "अपडेट करें",
  confirm: "पुष्टि करें",
  export_to_email: "निर्यात निम्नलिखित ई-मेल पर जाएगा।",
  start_chat_button: "नया संदेश",
  matching_existing_chats: "मौजूदा चैट से मेल खा रहे हैं",
  subject: "विषय",
  add_subject: "विषय जोड़ें",
  chat_subject: "चैट विषय:",
  set_project_room: "प्रोजेक्ट सेट करें",
  matching_existing_project_rooms: "मौजूदा प्रोजेक्टों से मेल खा रहे हैं",
  name_project_room: "प्रोजेक्ट नाम",
  professional_or_private: "पेशेवर या निजी",
  professional: "पेशेवर",
  privacy_modal_text_updated: "\"निजी\" का चयन केवल तभी करें यदि चैट में प्रोजेक्ट मैनेजर के लिए प्रासंगिक पेशेवर सामग्री नहीं है। निजी चैट प्रोजेक्ट मैनेजर को दिखाई नहीं देती हैं।",
  create_internal_chat: "बाहरी - या आंतरिक चैट?",
  internal_chat_description: "केवल आपकी कंपनी के कर्मचारियों को आंतरिक चैट में जोड़ा जा सकता है।",
  yes: "हां",
  no: "नहीं",
  chat_is_being_created: "चैट बनाई जा रही है...",
  discard_article_confirm: "क्या आप वाकई इस लेख में किए गए बदलाव रद्द करना चाहते हैं?",
  please_enter_article_title: "कृपया पहले लेख शीर्षक दर्ज करें।",
  please_add_mandatory_fields: "कृपया सभी अनिवार्य फ़ील्ड जोड़ें",
  product_label: "उत्पाद:",
  no_companies_found: "कोई कंपनी नहीं मिली",
  visible_to_all_followers: "सभी Kjuup सदस्यों को दिखाई देता है",
  only_visible_to_employees: "केवल कर्मचारियों को दिखाई देता है",
  something_went_wrong: "कुछ गलत हो गया, कृपया पुनः प्रयास करें",
  please_select_department: "कृपया विभाग/स्थान चुनें",
  schedule: "अनुसूची",
  please_select_future_date_time: "कृपया लेख को अनुसूचित करने के लिए भविष्य की तारीख और समय चुनें।",
  please_select_different_date_time: "कृपया लेख को अनुसूचित करने के लिए एक अलग तारीख या समय चुनें।",
  please_select_later_time: "कृपया आज के लिए वर्तमान समय से बाद का समय चुनें।",
  unpin_article: "लेख अनपिन करें",
  pin_article: "लेख पिन करें",
  and: "और",
  others: "अन्य",
  at: "पर",
  mute: "म्यूट करें",
  unmute: "अनम्यूट करें",
  chat_muted_successfully: "चैट सफलतापूर्वक म्यूट हो गई",
  chat_unmuted_successfully: "चैट सफलतापूर्वक अनम्यूट हो गई",
  mute_chat_confirm: "क्या आप वाकई इस चैट को म्यूट करना चाहते हैं? आपको नए संदेशों के लिए अब सूचनाएं नहीं मिलेंगी।",
  unmute_chat_confirm: "क्या आप वाकई इस चैट को अनम्यूट करना चाहते हैं? आपको फिर से नए संदेशों के लिए सूचनाएं मिलेंगी।",
  please_select_group_to_forward: "कृपया संदेश अग्रेषित करने के लिए समूह चुनें",
  record_not_found: "रिकॉर्ड नहीं मिला!",
  please_select_position: "कृपया स्थिति चुनें",
  delete_article_confirm: "क्या आप वाकई इस लेख को हटाना चाहते हैं?",
  delete_company_service_confirm: "क्या आप वाकई कंपनी सेवा को हटाना चाहते हैं?",
  block_translation_confirm: "क्या आप वाकई कंपनी के सभी सदस्यों के लिए प्रोजेक्टों में स्वचालित अनुवाद को ब्लॉक करना चाहते हैं",
  unblock_translation_confirm: "क्या आप वाकई कंपनी के सभी सदस्यों के लिए प्रोजेक्टों में स्वचालित अनुवाद को अनब्लॉक करना चाहते हैं",
  please_select_file: "कृपया अपलोड करने के लिए एक फ़ाइल चुनें",
  role_in_building_industry: "निर्माण उद्योग में भूमिका*",
  invalid_email_address: "अमान्य ईमेल पता",
  please_enter_password: "कृपया पासवर्ड दर्ज करें",
  password_change_email_sent: "आपके Kjuup ईमेल पर एक ईमेल भेजा गया है। ईमेल में दिए गए पुष्टिकरण लिंक पर क्लिक करके अपना नया पासवर्ड पुष्टि करें।",
  please_enter_username: "कृपया उपयोगकर्ता नाम दर्ज करें",
  username_same_as_before: "उपयोगकर्ता नाम पहले जैसा ही नहीं हो सकता",
  profile_deleted_successfully: "प्रोफ़ाइल सफलतापूर्वक हटाई गई",
  hardware_requirements: "हार्डवेयर आवश्यकताएं",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU गति न्यूनतम 2GHz<br/>• Windows 7 या उच्चतर / सभी macOS संस्करण",
  submitting: "सबमिट हो रहा है...",
  signing_in: "साइन इन हो रहा है...",
  please_enter_service_name: "कृपया सेवा नाम दर्ज करें",
  something_went_wrong_error: "आह! कुछ गलत हो गया...",
  something_went_wrong_try_again: "क्षमा करें, वहां कुछ गलत हो गया। पुनः प्रयास करें",
  position_label: "स्थिति:",
  loading_room: "प्रोजेक्ट लोड हो रहा है...",
  navigating_to_room: "प्रोजेक्ट में नेविगेट कर रहा है",
  loading_chat: "चैट लोड हो रही है...",
  translate: "अनुवाद करें",
  show_original: "मूल दिखाएं",
  saving: "सहेजा जा रहा है...",
  language_selection_info: "भाषा चयन का उपयोग कंपनी से संबंधित सभी ईमेल पुष्टि के लिए किया जाता है।",
  nav_call: "कॉल",
  nav_home: "होम",
  nav_messages: "संदेश",
  nav_todo: "कार्य",
  nav_rooms: "प्रोजेक्ट",
  nav_all_rooms: "सभी प्रोजेक्ट",
  pinned_rooms_max: "आप अधिकतम 10 प्रोजेक्ट पिन कर सकते हैं।",
  pinned_room_unpin: "अनपिन",
  pinned_rooms_drop: "त्वरित चयन के लिए अपना प्रोजेक्ट यहाँ खींचें",
  nav_profile: "प्रोफ़ाइल",
  nav_company: "कंपनी",
  nav_company_documents: "दस्तावेज़",
  nav_logout: "लॉगआउट",
  add_member_title: "सदस्य जोड़ें",
  continue_btn: "जारी रखें",
  search_placeholder: "खोजें",
  no_members_found: "कोई सदस्य नहीं मिला",
  no_groups_found: "कोई समूह नहीं मिला",
  no_rooms_found: "कोई प्रोजेक्ट नहीं मिला",
  search_users_tab: "उपयोगकर्ता",
  search_documents_tab: "दस्तावेज़",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "कोई फ़ाइल नहीं",
  no_documents_available: "No documents",
  searching_users: "उपयोगकर्ता खोज रहे हैं...",
  no_users_found: "कोई उपयोगकर्ता नहीं मिला",
  search_emails_tab: "ईमेल",
  searching_emails: "ईमेल खोजे जा रहे हैं...",
  no_emails_found: "कोई ईमेल नहीं मिला",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "अनाम समूह",
  unnamed_room: "अनाम प्रोजेक्ट",
  all_members: "सभी",
  room_label: "प्रोजेक्ट:",
  subject_label: "विषय:",
  no_members: "कोई सदस्य नहीं",
  creating_structure: "आपकी संरचना बनाई जा रही है",
  opening_chat: "चैट खोली जा रही है",
  please_wait: "कृपया प्रतीक्षा करें...",
  loading_todo: "ToDo लोड हो रहा है...",
  task_updated: "कार्य अपडेट किया गया",
  error_updating_task: "कार्य अपडेट करने में त्रुटि",
  task_deleted: "कार्य हटा दिया गया",
  error_deleting_task: "कार्य हटाने में त्रुटि",
  delete_task_confirm: "क्या आप वाकई इस कार्य को हटाना चाहते हैं?",
  description_label: "विवरण",
  description_placeholder: "विवरण दर्ज करें...",
  date_time_label: "तारीख और समय",
  save_hint: "सहेजने के लिए Ctrl+Enter, रद्द करने के लिए Esc",
  edit_label: "संपादित करें",
  delete_label: "हटाएं",
  todo_list_title: "कार्य",
  tasks_count: "कार्य",
  search_placeholder_todo: "खोजें...",
  select_task_to_open_chat: "चैट खोलने के लिए एक कार्य चुनें",
  today: "आज",
  yesterday: "कल",
  time_suffix: "",
  from_chat: "स्रोत ToDo",
  assigned_to: "असाइन किया गया",
  assign_users: "उपयोगकर्ता असाइन करें",
  no_users_assigned: "कोई उपयोगकर्ता असाइन नहीं",
  assign: "असाइन करें",
  assign_to: "असाइन करें...",
  navigate_to_chat: "चैट पर नेविगेट करें",
  navigate_to_email: "ईमेल पर जाएँ",
  show_original_message: "स्रोत दिखाएं",
  hide_original_message: "स्रोत छुपाएं",
  status_pending: "लंबित",
  status_in_progress: "प्रगति में",
  status_completed: "पूर्ण",
  show: "दिखाएं",
  close: "बंद करें",
  status_confirmed: "[पुष्ट]",
  log_todo_created: "ToDo [बनाया गया]",
  log_todo_confirmed: "ToDo [पुष्ट किया गया]",
  log_todo_deleted: "ToDo [हटाया गया]",
  log_todo_updated: "ToDo [अपडेट किया गया]",
  log_description_updated: "[विवरण अपडेट किया गया]",
  log_deadline_updated: "[समय सीमा अपडेट की गई]",
  log_assigned_to: "[को असाइन किया गया] {name}",
  log_unassigned_from: "[से असाइनमेंट हटाया गया] {name}",
  log_assignment_added: "[असाइनमेंट जोड़ा गया]: {name}",
  log_assignment_removed: "[असाइनमेंट हटाया गया]: {name}",
  log_status_updated: "[स्थिति बदली गई] {from} [से] {to}",
  log_status_changed: "[स्थिति बदली गई]",
  log_status_changed_to: "[स्थिति बदली गई] {status}",
  log_changed_status_to: "[स्थिति बदली गई]:",
  log_for_user: "[उपयोगकर्ता के लिए]:",
  log_user_updated_status: "[उपयोगकर्ता ने अपनी todo स्थिति अपडेट की]",
  log_changed_date_to: "[तारीख बदली गई]:",
  log_changed_description_to: "[विवरण बदला गया]:",
  log_moved_to: "[स्थानांतरित किया गया] {status}",
  todo_status_updated_from: "[से]",
  todo_status_updated_to: "[को]",
  filter_pending: "लंबित",
  filter_confirmed: "पुष्टि हुई",
  filter_assigned_to_me: "मेरे कार्य",
  filter_assigned_by_me: "प्रत्यायोजित",
  todo_project_label: "परियोजना:",
  assigned_users: "नियुक्त उपयोगकर्ता:",
  todo_chat_label: "चैट:",
  history: "इतिहास",
  todo_assigned_by: "द्वारा सौंपा गया:",
  todo_assigned_push: "असाइन किया गया ToDo:",
  todo_assigned_push_empty: "आपको एक नया ToDo असाइन किया गया है।",
  search_groups: "समूह",
  search_chat_groups: "चैट समूह",
  search_project_room: "प्रोजेक्ट",
  search_messages_tab: "संदेश",
  searching_groups: "समूह खोजे जा रहे हैं...",
  searching_rooms: "प्रोजेक्ट खोजे जा रहे हैं...",
  no_groups_found: "कोई समूह नहीं मिला",
  no_rooms_found: "कोई प्रोजेक्ट नहीं मिला",
  create_poll: "Poll",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Ask a question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Add option",
  poll_allow_multiple: "Allow multiple answers",
  poll_multiple_allowed: "Select one or more options",
  poll_select_option: "Select one option",
  poll_view_votes: "View votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Poll votes",
  poll_no_votes_yet: "No votes yet",
  transcript_step_processing: "ट्रांसक्रिप्शन जारी है...",
  ai_transcript_tab: "AI-ट्रांसक्रिप्ट",
  ai_transcript_info: "केवल 09.03.2026 के बाद बनाए गए वॉइस मैसेज के लिए उपलब्ध।",
  transcript_more: "...और",
  transcript_less: "...कम",
  ki_transcript_voice_message: "KI-ध्वनि संदेश का प्रतिलेख",
  ki_image_analysis: "AI-संचालित छवि विश्लेषण",
  type_message: "संदेश टाइप करें",
  email_tab_messages: "संदेश",
  email_tab_email: "ईमेल",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "ईमेल खाते",
  email_connect_gmail: "Gmail कनेक्ट करें",
  email_connect_outlook: "Outlook कनेक्ट करें",
  email_no_accounts: "कोई ईमेल खाता कनेक्ट नहीं",
  email_no_accounts_hint: "अपनी प्रोफ़ाइल सेटिंग्स में ईमेल खाता कनेक्ट करें",
  email_no_messages: "कोई ईमेल नहीं",
  email_from: "से",
  email_to: "को",
  email_subject: "विषय",
  email_disconnect: "डिस्कनेक्ट करें",
  email_disconnect_confirm: "क्या आप वाकई इस ईमेल खाते को डिस्कनेक्ट करना चाहते हैं? सभी सिंक किए गए ईमेल हटा दिए जाएंगे।",
  email_account_disconnected: "ईमेल खाता सफलतापूर्वक डिस्कनेक्ट किया गया",
  email_account_disconnect_failed: "खाता डिस्कनेक्ट करने में विफल",
  email_connecting: "कनेक्ट हो रहा है...",
  email_account_connected: "खाता सफलतापूर्वक कनेक्ट हो गया",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "सेटिंग्स पर जाएं",
  email_date: "तारीख",
  email_reply: "जवाब दें",
  email_forward: "अग्रेषित करें",
  email_copy_text: "टेक्स्ट कॉपी करें",
  email_text_copied: "कॉपी हो गया!",
  email_text_copy_failed: "टेक्स्ट कॉपी नहीं किया जा सका।",
  email_delete: "हटाएं",
  email_not_spam: "स्पैम नहीं",
  email_not_spam_success: "ईमेल इनबॉक्स में ले जाया गया।",
  email_not_spam_failed: "इनबॉक्स में ले जाने में विफल।",
  email_delete_confirm: "क्या आप वाकई इस ईमेल को हटाना चाहते हैं?",
  email_delete_from_folder: "क्या आप वाकई {folder} से हटाना चाहते हैं?",
  email_delete_permanent_from_folder:
    "क्या आप वाकई {folder} से स्थायी रूप से हटाना चाहते हैं? यह कार्रवाई पूर्ववत नहीं की जा सकती।",
  email_save_draft_confirm: "क्या आप इस ईमेल को ड्राफ्ट के रूप में सहेजना चाहते हैं?",
  email_save_draft: "ड्राफ्ट सहेजें",
  email_discard: "छोड़ें",
  email_back_to_compose: "लिखने पर वापस जाएँ",
  email_draft_saved: "ड्राफ्ट सहेजा गया।",
  email_draft_save_failed: "ड्राफ्ट सहेजने में विफल।",
  email_loading: "ईमेल लोड हो रहे हैं...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Select",
  email_attachment_singular: "Attachment",
  email_attachment_plural: "Attachments",
  email_back: "Back",
  email_download: "Download",
  email_close: "Close",
  email_preview: "Preview",
  email_preview_not_available: "पूर्वावलोकन उपलब्ध नहीं है",
  email_preview_failed: "पूर्वावलोकन उपलब्ध नहीं है",
  select_attachments: "अटैचमेंट चुनें",
  email_loading_preview: "Loading preview...",
  email_mark_unread_failed: "email(s) could not be marked as unread.",
  email_delete_failed: "email(s) could not be deleted.",
  filter_all: "सभी",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "प्रत्यक्ष संदेश",
  my_notes: "My Space",
  filter_internal_groups: "आंतरिक समूह चैट",
  filter_external_groups: "बाहरी समूह चैट",
  filter_group_chats: "समूह चैट",
  filter_groups_internal: "आंतरिक",
  filter_groups_external: "बाहरी",
  filter_unread_only: "केवल अपठित",
  room_daily_briefing_info: "सक्षम होने पर, इस प्रोजेक्ट की रिपोर्ट व्यक्तिगत सेटिंग में बताए गए समय पर हर 24 घंटे में बनाई जाती है — लेकिन केवल तभी जब उस अवधि में गतिविधि हुई हो।",
  email_select_all: "सभी चुनें",
  email_deselect_all: "सभी अचयनित करें",
  email_reply_all: "सभी को उत्तर दें",
  email_reply_placeholder: "अपना उत्तर लिखें...",
  email_forward_placeholder: "संदेश जोड़ें...",
  email_edit_draft: "ड्राफ्ट संपादित करें",
  email_attach: "संलग्न करें",
  email_attachment_from_original: "मूल संदेश से",
  email_remove: "हटाएं",
  email_drop_files: "संलग्न करने के लिए फ़ाइलें छोड़ें",
  email_loading_attachments: "अनुलग्नक लोड हो रहे हैं...",
  email_archive: "संग्रह",
  mark_unread: "अपठित के रूप में चिह्नित करें",
  mark_read: "पठित के रूप में चिह्नित करें",
  email_all_accounts: "सभी खाते",
  email_error: "त्रुटि",
  email_delete_email_failed: "ईमेल हटाने में विफल।",
  enter_url: "URL दर्ज करें",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'अभी सदस्यता लें',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 महीना मुफ़्त ट्रायल',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'आज कोई भुगतान नहीं। पेड सब्सक्रिप्शन शुरू होने से पहले क्रेडिट कार्ड विवरण नहीं मांगे जाते।',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'सभी ईमेल खाते सीधे Kjuup में प्रबंधित करें',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI जवाब लिखता है – आप सिर्फ पुष्टि करें',
  kjuup_io_feature_tasks: 'कार्य और कैलेंडर हमेशा स्वचालित रूप से अपडेट',
  kjuup_io_choose_plan: 'प्लान चुनें',
  kjuup_io_plan_monthly: 'मासिक',
  kjuup_io_plan_yearly: 'वार्षिक',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe द्वारा सुरक्षित · कभी भी रद्द करें',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'भुगतान प्राप्त हुआ। आपकी सदस्यता सक्रिय की जा रही है…',
  kjuup_io_toast_activating_soon: 'भुगतान प्राप्त हुआ। आपकी सदस्यता जल्द ही सक्रिय होगी।',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} घंटे शेष',
  kjuup_io_trial_left_hour: '1 घंटा शेष',
  kjuup_io_trial_left_minutes: '{count} मिनट शेष',
  kjuup_io_trial_left_minute: '1 मिनट शेष',
  kjuup_io_trial_left_seconds: '{count} सेकंड शेष',
  kjuup_io_trial_left_second: '1 सेकंड शेष',
  kjuup_io_trial_ending_now: 'आपका ट्रायल समाप्त हो रहा है…',
  kjuup_io_request_timeout: 'कनेक्शन का समय समाप्त हो गया। कृपया दोबारा कोशिश करें।',
  kjuup_io_info_days_free: '{days} दिन पूरी तरह मुफ़्त – सब्सक्रिप्शन ट्रायल के बाद ही शुरू होती है।',
  kjuup_io_discount_total: 'आपकी छूट: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'व्यक्तिगत: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'बंद करें',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'आपका निःशुल्क ट्रायल समाप्त हो गया है',
  kjuup_io_trial_ended_body: 'ईमेल और अन्य प्रीमियम सुविधाओं का उपयोग जारी रखने के लिए Kjuup.io की सदस्यता लें।',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'आपका निःशुल्क ट्रायल शुरू हो गया है',
  kjuup_io_toast_trial_fail: 'निःशुल्क ट्रायल शुरू नहीं हो सका',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / महीना',
  kjuup_io_save_amount_year: 'प्रति वर्ष {price} बचाएँ',
  kjuup_io_billed_annually_amount: '{price} वार्षिक बिलिंग',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'आपको क्या मिलता है:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'क्रेडिट कार्ड की आवश्यकता नहीं – भुगतान विवरण के बिना तुरंत शुरू करें।',
  kjuup_io_info_cancel_anytime: 'कभी भी रद्द करें – कोई बाध्यता नहीं, कोई जोखिम नहीं।',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'बिलिंग अवधि',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'भुगतान विधि सहेजी गई। ट्रायल समाप्त होने पर शुल्क लिया जाएगा।',
  calendar_sync_info: 'सभी Kjuup ToDo को अपने कैलेंडर के साथ स्वचालित रूप से सिंक करें।',
  calendar_no_accounts: 'अभी तक कोई कैलेंडर कनेक्ट नहीं है।',
  article_new_badge: 'नया',
  article_new_posts: '{0} नई पोस्ट',
  documents: 'दस्तावेज़',
  add_documents: 'दस्तावेज़ जोड़ें',
  no_preview_available: 'कोई पूर्वावलोकन उपलब्ध नहीं',
  no_preview_hint: 'इस प्रकार की फ़ाइल का पूर्वावलोकन नहीं किया जा सकता, लेकिन इसे फिर भी भेजा जाएगा।',
  max_documents_reached: 'आप एक बार में अधिकतम 10 दस्तावेज़ संलग्न कर सकते हैं।',
  open_file: 'फ़ाइल खोलें',
  twofa_title: 'दो-चरणीय प्रमाणीकरण',
  twofa_method_totp: 'ऑथेंटिकेटर ऐप',
  twofa_method_sms: 'टेक्स्ट संदेश',
  twofa_method_email: 'ईमेल',
  twofa_enter_app: 'अपने ऑथेंटिकेटर ऐप से 6 अंकों का कोड दर्ज करें।',
  twofa_enter_sms: 'हमने एसएमएस से भेजा 6 अंकों का कोड दर्ज करें।',
  twofa_enter_email: 'हमने आपके ईमेल पर भेजा 6 अंकों का कोड दर्ज करें।',
  twofa_resend: 'कोड फिर से भेजें',
  twofa_try_another: 'दूसरी विधि आज़माएँ',
  twofa_remember_device: 'इस डिवाइस पर 30 दिनों तक न पूछें',
  twofa_sent: 'हमने एक कोड भेजा है।',
  twofa_invalid_code: 'यह कोड गलत है। कृपया फिर से प्रयास करें।',
  twofa_something_wrong: 'कुछ गलत हो गया। कृपया फिर से प्रयास करें।',
  twofa_method_unavailable: 'यह सत्यापन विधि उपलब्ध नहीं है।',
  twofa_on_desc: 'दो-चरणीय प्रमाणीकरण चालू है। हर साइन इन पर कोड लगेगा।',
  twofa_off_desc: 'पासवर्ड के बाद एक दूसरा चरण जोड़ें। ऑथेंटिकेटर ऐप सबसे सुरक्षित हैं।',
  twofa_methods: 'विधियाँ',
  twofa_on: 'चालू',
  twofa_add: 'जोड़ें',
  twofa_default_method: 'डिफ़ॉल्ट विधि',
  twofa_default: 'डिफ़ॉल्ट',
  twofa_turn_off: 'बंद करें',
  twofa_disable_hint: 'दो-चरणीय प्रमाणीकरण बंद करने के लिए पासवर्ड और वर्तमान कोड दर्ज करें।',
  twofa_disable_need: 'पासवर्ड और सत्यापन कोड दर्ज करें।',
  twofa_code_placeholder: '6 अंकों का कोड या बैकअप कोड',
  twofa_send_code: 'कोड भेजें',
  twofa_primary_updated: 'डिफ़ॉल्ट सत्यापन विधि अपडेट हो गई।',
  twofa_disabled: 'दो-चरणीय प्रमाणीकरण अब बंद है।',
  twofa_enabled: 'दो-चरणीय प्रमाणीकरण अब चालू है।',
  twofa_totp_help: 'इस QR कोड को Google Authenticator, Authy या 1Password से स्कैन करें। कुंजी हाथ से भी दर्ज कर सकते हैं।',
  twofa_secret_copied: 'कुंजी कॉपी हो गई',
  twofa_sms_help: 'अंतरराष्ट्रीय प्रारूप में मोबाइल नंबर दर्ज करें। हम 6 अंकों का कोड एसएमएस से भेजेंगे।',
  twofa_email_help: 'हम आपके खाते के ईमेल पर 6 अंकों का कोड भेजेंगे।',
  twofa_backup_title: 'बैकअप कोड',
  twofa_backup_help: 'इन एक बार वाले कोड को सुरक्षित जगह रखें। फ़ोन खोने पर हर कोड एक बार चलता है।',
  twofa_copy_codes: 'कोड कॉपी करें',
  twofa_codes_copied: 'बैकअप कोड कॉपी हो गए',
  twofa_regenerate: 'नए बैकअप कोड प्राप्त करें',
  twofa_regenerate_hint: 'इससे अप्रयुक्त बैकअप कोड बदल जाएंगे। अपना पासवर्ड और वर्तमान कोड दर्ज करें।',
  twofa_backup_remaining: '{n} अप्रयुक्त बैकअप कोड शेष',
  twofa_new_codes: 'नए बैकअप कोड',
  twofa_sms_unavailable: 'एसएमएस कोड अभी उपलब्ध नहीं हैं।',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "आपको सौंपे गए Kjuup कार्य आपके Todoist के Kjuup प्रोजेक्ट में कॉपी होते हैं। Todoist में किए बदलाव वापस कॉपी नहीं होते।",
  todoist_connect: "Todoist जोड़ें",
  todoist_connected: "Todoist जुड़ गया",
  todoist_connect_failed: "Todoist कनेक्शन विफल",
  todoist_disconnect: "डिस्कनेक्ट करें",
  todoist_disconnected: "Todoist डिस्कनेक्ट हो गया",
  todoist_disconnect_confirm: "Todoist डिस्कनेक्ट करें? Todoist में जो कार्य पहले से हैं वे रहेंगे। सिंक रुक जाएगा।",
  todoist_sync_now: "अभी सिंक करें",
  todoist_syncing: "सिंक हो रहा है…",
  todoist_sync_done: "सिंक पूरा हुआ",
  todoist_sync_failed: "सिंक विफल",
  todoist_auth_error: "सिंक जारी रखने के लिए Todoist फिर से जोड़ें।",
  todoist_last_sync: "अंतिम सिंक",
  todoist_not_connected: "Todoist जुड़ा नहीं है",
  todoist_auth_url_failed: "Todoist अनुमति पृष्ठ नहीं खुल सका।",
  recommend_text: "Kjuup से जुड़ो, जुड़े रहो और अपनी बातचीत व्यवस्थित रखो। अपने सभी चैनल एक जगह लाओ, संदेशों को सही प्रोजेक्टों में रखो और हर सुबह की शुरुआत एक सारांश और अपने कार्यों के साथ करो – सब कुछ उन ऐप्स के साथ सिंक, जिन्हें तुम पहले से इस्तेमाल करते हो। मुफ़्त में शुरू करो:",
  pro_auth_signin_title: 'फिर से स्वागत है',
  pro_auth_signin_sub: 'अपने कार्य ई-मेल से साइन इन करें।',
  pro_auth_email_or_username: 'ई-मेल या उपयोगकर्ता नाम',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'पासवर्ड भूल गए?',
  pro_auth_create_account: 'खाता बनाएँ',
  pro_auth_show_password: 'पासवर्ड दिखाएँ',
  pro_auth_hide_password: 'पासवर्ड छिपाएँ',
  pro_auth_register_sub: 'हम आपको आपके ई-मेल की पुष्टि के लिए एक लिंक भेजेंगे।',
  pro_auth_register_plus_sub: 'एक उपयोगकर्ता नाम और पासवर्ड चुनें। इसके बाद आप अपना सुरक्षा PIN सेट करेंगे।',
  pro_auth_check_credentials: 'अपना ई-मेल और पासवर्ड जाँचें',
  pro_news_export_pdf: 'PDF के रूप में निर्यात करें',
  pro_news_pdf_failed: 'PDF नहीं बनाई जा सकी।',
  pro_news_pdf_attachments: 'अटैचमेंट',
  pro_news_pdf_video: 'वीडियो',
  pro_auth_forgot_sub: 'अपना ई-मेल दर्ज करें और हम आपको पासवर्ड रीसेट करने के लिए एक लिंक भेजेंगे।',
  pro_auth_send_link: 'रीसेट लिंक भेजें',
  pro_auth_plus_reset: 'PIN से रीसेट करें',
  pro_auth_show_pin: 'PIN दिखाएँ',
  pro_auth_hide_pin: 'PIN छिपाएँ',
  v2_auth_plus_only: 'केवल Kjuup+',
  room_action_media: "फ़ाइलें",
  room_tab_overview: "अवलोकन",
  room_tab_history: "इतिहास",
  chat_info_media: "फ़ाइलें",
  messages: "संदेश",
  pro_todo_project_required: "कृपया एक प्रोजेक्ट चुनें",
  pro_todo_choose_project: "यह कार्य किस प्रोजेक्ट के लिए है?",
  cockpit_report_delete_confirm: "इस दैनिक रिपोर्ट को हटाएँ?",
  cockpit_report_deleted: "दैनिक रिपोर्ट हटा दी गई",
  cockpit_tab_company: "कंपनी",
  cockpit_bookmarked_priorities: "बुकमार्क किए गए कार्य",
  cockpit_load_error: "कॉकपिट लोड नहीं हो सका।",
  cockpit_retry: "फिर कोशिश करें",
  cockpit_yesterday: "कल",
  cockpit_greeting_morning: "सुप्रभात",
  cockpit_greeting_day: "शुभ दोपहर",
  cockpit_greeting_evening: "शुभ संध्या",
  cockpit_assistant_q_open: "आज क्या बाकी है?",
  cockpit_assistant_q_summarize: "चैट {{room}} का सारांश दें",
  cockpit_assistant_q_overdue: "कौन से कार्य अतिदेय हैं?",
  cockpit_assistant_new: "{{n}} नए",
  cockpit_assistant_important: "{{n}} महत्वपूर्ण",
  cockpit_assistant_title: "Kjuup सहायक",
  cockpit_assistant_hint: "टैप करें और पूछें",
  room_overview_priority_no_detail: "रिपोर्ट इस प्राथमिकता के बारे में कोई और जानकारी नहीं देती।",
  room_overview_priority_from: "स्रोत: {{name}}",
  room_overview_priority_open_task: "कार्य खोलें",
  cockpit_priority_position: "{{total}} में से {{index}} प्राथमिकता",
  room_overview_today_title: "आज ज़रूरी",
  room_overview_all_tasks: "सभी",
  room_overview_tasks_empty: "कोई खुली समय-सीमा या कार्य नहीं",
  room_overview_appointments_empty: "कोई आगामी अपॉइंटमेंट नहीं",
  room_overview_no_priorities: "नवीनतम रिपोर्ट में कोई खुली प्राथमिकता नहीं है।",
  cockpit_report_top5: "शीर्ष 5 प्राथमिकताएँ",
  cockpit_report_todo_created: "ToDo बनाया गया",
  cockpit_report_source_missing: "स्रोत संदेश नहीं मिला।",
  delete_bookmarked_priority_confirm: "क्या आप वाकई इस बुकमार्क किए गए कार्य को हटाना चाहते हैं?",
  cockpit_report_create_todo: "ToDo बनाएँ",
  cockpit_priorities_deleting: "हटाया जा रहा है …",
  cockpit_priorities_select: "कई हटाएँ",
  cockpit_report_none: "कोई प्रविष्टि नहीं।",
  cockpit_priorities_delete_confirm: "क्या आप वाकई {count} बुकमार्क किए गए कार्य हटाना चाहते हैं?",
  cockpit_priorities_delete_failed: "{count} कार्य हटाए नहीं जा सके",
  cockpit_priorities_deleted: "{count} कार्य हटाए गए",
  cockpit_priorities_selected: "{count} चुने गए",
  cockpit_channel_connected: "कनेक्टेड",
  cockpit_channel_not_connected: "कनेक्ट नहीं है",
  cockpit_channel_connect: "कनेक्ट करें",
  cockpit_channel_chat: "Kjuup चैट",
  cockpit_channel_active: "सक्रिय",
  cockpit_channel_hidden: "छिपा हुआ",
  cockpit_channel_enable: "सक्षम करें",
  cockpit_channel_email: "ईमेल",
  cockpit_channel_check: "कनेक्शन जाँचें",
  cockpit_channel_fix: "जाँचें",
  cockpit_channel_forward: "फ़ॉरवर्डिंग पता",
  cockpit_channel_not_set_up: "सेट अप नहीं है",
  cockpit_channel_set_up: "सेट अप करें",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "कनेक्शन टूट गया",
  cockpit_channel_importing: "आयात हो रहा है",
  cockpit_channel_removing: "डिस्कनेक्ट हो रहा है",
  cockpit_channel_reconnect: "फिर से कनेक्ट करें",
  cockpit_channels_title: "चैनल",
  cockpit_company_role_super_admin: "कंपनी एडमिन",
  cockpit_company_role_dept_admin: "विभाग एडमिन",
  cockpit_company_role_member: "कर्मचारी",
  cockpit_company_none: "कोई Kjuup+ कंपनी नहीं मिली",
  cockpit_company_eyebrow: "कंपनी",
  cockpit_company_inactive: "निष्क्रिय",
  cockpit_company_settings: "कंपनी सेटिंग्स",
  cockpit_company_employees: "कर्मचारी",
  cockpit_company_internal_rooms: "आंतरिक प्रोजेक्ट",
  cockpit_report_all_projects: "सभी प्रोजेक्ट",
  cockpit_report_progress_emails: "ईमेल का विश्लेषण हो रहा है",
  cockpit_report_progress_chats: "चैट संदेशों का विश्लेषण हो रहा है",
  cockpit_report_progress_documents: "अटैचमेंट और दस्तावेज़ों का विश्लेषण हो रहा है",
  cockpit_report_progress_tasks: "कार्यों का विश्लेषण हो रहा है",
  cockpit_report_progress_summarizing: "सामग्री का विश्लेषण हो रहा है",
  cockpit_report_progress_reading: "पहले से विश्लेषित सामग्री का दोबारा उपयोग हो रहा है",
  cockpit_report_progress_collecting: "आपके प्रोजेक्ट से ईमेल, चैट और कार्य इकट्ठा किए जा रहे हैं",
  cockpit_report_progress_priorities: "प्राथमिकताएँ, समय-सीमाएँ और निर्णय तैयार किए जा रहे हैं",
  cockpit_report_progress_queued: "रिपोर्ट तैयार की जा रही है",
  cockpit_report_creating_title: "आपकी दैनिक रिपोर्ट तैयार की जा रही है",
  cockpit_report_progress_count_one: "1 आइटम का विश्लेषण हुआ",
  cockpit_report_progress_count_many: "{{count}} आइटम का विश्लेषण हुआ",
  cockpit_report_progress_hint: "इसमें आमतौर पर एक से दो मिनट लगते हैं – इस बीच आप कॉकपिट का उपयोग जारी रख सकते हैं।",
  cockpit_report_time_hint: "दैनिक रिपोर्ट हर दिन {{hour}}:00 बजे सबसे सक्रिय पाँच प्रोजेक्ट के लिए बनती है।",
  room_overview_priorities_title: "वर्तमान स्थिति और प्राथमिकताएँ",
  room_overview_as_of: "{{time}} तक",
  cockpit_report_delete: "दैनिक रिपोर्ट हटाएँ",
  email_tag_daily_briefing: "दैनिक रिपोर्ट",
  cockpit_report_unread: "नया",
  cockpit_report_clear_project: "सभी प्रोजेक्ट दिखाएँ",
  cockpit_filter_project: "प्रोजेक्ट",
  cockpit_filter_all_projects: "सभी प्रोजेक्ट",
  cockpit_report_recreate: "दैनिक रिपोर्ट दोबारा बनाएँ",
  cockpit_report_hide_previous: "पिछली दैनिक रिपोर्ट छिपाएँ",
  cockpit_report_show_previous: "पिछली दैनिक रिपोर्ट दिखाएँ",
  cockpit_report_room_empty: "इस प्रोजेक्ट की अभी कोई दैनिक रिपोर्ट नहीं है",
  cockpit_report_empty: "अभी कोई दैनिक रिपोर्ट नहीं है",
  cockpit_report_room_empty_hint: "केवल इस प्रोजेक्ट के लिए दैनिक रिपोर्ट बनाएँ।",
  cockpit_report_needs_mailbox: "ईमेल खाता कनेक्ट करें ताकि Kjuup स्वचालित कार्यों के साथ दैनिक रिपोर्ट बना सके।",
  cockpit_report_create: "दैनिक रिपोर्ट बनाएँ",
  cockpit_email_connect: "ईमेल कनेक्ट करें",
  cockpit_email_none_title: "अभी कोई ईमेल खाता कनेक्ट नहीं है",
  cockpit_email_none_reports: "अपना मेलबॉक्स कनेक्ट करें ताकि Kjuup आने वाले ईमेल को आपके प्रोजेक्ट से जोड़ सके और कार्यों के साथ दैनिक रिपोर्ट बना सके।",
  cockpit_email_none_client: "Kjuup.io में सीधे ईमेल पढ़ने, असाइन करने और जवाब देने के लिए Gmail, Outlook या IMAP कनेक्ट करें।",
  cockpit_email_reports_title: "मौजूदा ईमेल क्लाइंट",
  cockpit_email_reports_text: "Kjuup.io में कोई इनबॉक्स नहीं · {{rooms}} प्रोजेक्ट, दैनिक रिपोर्ट {{hour}}:00 बजे · आने वाले ईमेल आपके प्रोजेक्ट से जोड़े जाते हैं।",
  cockpit_email_reports_rooms: "प्रोजेक्ट प्रबंधित करें",
  cockpit_email_settings: "ईमेल सेटिंग्स",
  cockpit_email_error_title: "कनेक्शन जाँचें",
  cockpit_email_client_title: "इनबॉक्स कनेक्टेड",
  cockpit_email_accounts_n: "{{n}} खाता कनेक्टेड",
  cockpit_email_last_sync: "अंतिम सिंक {{when}}",
  cockpit_email_report_at: "दैनिक रिपोर्ट {{hour}}:00 बजे",
  cockpit_email_open_inbox: "इनबॉक्स खोलें",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "कनेक्टेड ईमेल पते",
  email_folder_sent: "भेजे गए आइटम",
  email_no_subject: "(कोई विषय नहीं)",
  cockpit_email_detail_loading: "ईमेल लोड हो रहा है …",
  cockpit_email_detail_failed: "ईमेल लोड नहीं हो सका।",
  cockpit_email_detail_empty: "इस ईमेल में कोई टेक्स्ट नहीं है।",
  cockpit_personal_settings: "व्यक्तिगत सेटिंग्स",
  cockpit_companies: "कंपनियाँ",
  cockpit_title: "कॉकपिट",
  cockpit_back: "ओवरव्यू पर वापस जाएँ",
  cockpit_day_overview: "आपका दिन एक नज़र में",
  email_saved_to_project: "ईमेल प्रोजेक्ट में सहेजा गया",
  email_classify_need_project: "कृपया प्रोजेक्ट का नाम दर्ज करें",
  cockpit_email_deleted: "ईमेल हटा दिया गया",
  cockpit_email_sent_empty: "अभी कोई भेजा गया ईमेल नहीं है।",
  cockpit_email_incoming_empty: "अभी कोई आने वाला ईमेल नहीं है।",
  cockpit_email_incoming_title: "ईमेल",
  cockpit_email_incoming_sub: "आने वाले और भेजे गए ईमेल को अपने प्रोजेक्ट से जोड़ें। आप यहाँ असाइनमेंट बदल सकते हैं।",
  cockpit_email_incoming_unassigned_n: "{{n}} असाइन नहीं हैं",
  cockpit_email_folder_inbox: "इनबॉक्स",
  cockpit_email_folder_sent: "भेजे गए",
  cockpit_email_open: "ईमेल खोलें",
  cockpit_email_incoming_suggested: "सुझाव: {{room}}",
  cockpit_email_incoming_apply: "लागू करें",
  cockpit_email_incoming_adjust: "असाइनमेंट बदलें",
  cockpit_email_incoming_saving: "सहेजा जा रहा है …",
  cockpit_email_incoming_unassigned: "असाइन नहीं है",
  cockpit_email_incoming_show_less: "कम दिखाएँ",
  cockpit_email_incoming_show_all: "सभी {{n}} दिखाएँ",
  cockpit_io_settings: "Kjuup.io सेटिंग्स",
  cockpit_io_settings_sub: "प्लान और सीटें, कर्मचारी असाइनमेंट, बिलिंग और इनवॉइस।",
  products_coming_soon: "जल्द आ रहा है",
  cockpit_upsell_io_title: "आपका सोच-समझकर साथ चलने वाला ऑफ़िस",
  cockpit_upsell_io_text: "अपने ईमेल खाते Kjuup से कनेक्ट करें। ईमेल, अटैचमेंट और संदेश अपने आप संबंधित प्रोजेक्ट में सहेजे जाते हैं और चाहें तो आपके सर्वर पर संग्रहीत किए जा सकते हैं। हर दिन आपको सभी प्रोजेक्ट का सारांश मिलता है, जिसमें सारी सामग्री के मुख्य बिंदु होते हैं, और आपके कार्य आपके कैलेंडर या to-do ऐप के साथ सिंक होते हैं।",
  cockpit_upsell_io_soon_title: "अभी बुक नहीं किया जा सकता",
  cockpit_upsell_io_soon_text: "Kjuup.io जल्द लॉन्च हो रहा है। अभी जानकारी का अनुरोध करें – Kjuup.io बुक करने योग्य होते ही हम आपको बता देंगे।",
  cockpit_upsell_io_planned_price: "नियोजित मूल्य",
  cockpit_upsell_io_cta_request: "जानकारी का अनुरोध करें",
  kjuup_plus_abo_per_year: "/ वर्ष",
  kjuup_plus_abo_per_month: "/ माह",
  kjuup_plus_abo_status_active: "सक्रिय",
  kjuup_plus_abo_status_requested: "रद्दीकरण का अनुरोध किया गया",
  kjuup_plus_abo_status_past_due: "भुगतान बकाया",
  kjuup_plus_abo_eyebrow: "Kjuup+ · सदस्यता",
  kjuup_plus_abo_title: "Kjuup+ पैकेज",
  kjuup_plus_abo_seats_free_one: "1 सीट बाकी",
  kjuup_plus_abo_billing: "बिलिंग",
  kjuup_plus_abo_yearly: "वार्षिक",
  kjuup_plus_abo_monthly: "मासिक",
  kjuup_plus_abo_amount: "राशि",
  kjuup_plus_abo_ends: "समाप्ति तिथि",
  kjuup_plus_abo_renews: "अगला नवीनीकरण",
  kjuup_plus_abo_next_invoice: "अगला इनवॉइस",
  kjuup_plus_abo_intro: "परिचयात्मक मूल्य",
  kjuup_plus_abo_pending_tier: "अगले नवीनीकरण से",
  kjuup_plus_abo_manual: "Kjuup+ आपकी कंपनी के लिए व्यक्तिगत समझौते के तहत सक्रिय है।",
  kjuup_plus_abo_invoices: "इनवॉइस",
  kjuup_plus_abo_invoice_paid: "भुगतान किया गया",
  kjuup_plus_abo_invoice_view: "देखें",
  kjuup_plus_abo_invoices_less: "कम दिखाएँ",
  kjuup_plus_abo_member_hint: "बिलिंग और रद्दीकरण आपकी कंपनी के एडमिन संभालते हैं।",
  kjuup_plus_abo_withdraw: "अनुरोध वापस लें",
  kjuup_plus_abo_cancel_note: "कारण (वैकल्पिक)",
  kjuup_plus_abo_cancel_send: "रद्दीकरण का अनुरोध करें",
  kjuup_plus_abo_cancel: "सदस्यता रद्द करें",
  cockpit_upsell_plus_f1: "अपने सभी कर्मचारियों की संचार गतिविधि प्रबंधित करें",
  cockpit_upsell_plus_f2: "कंपनी में विशेष उपयोगकर्ता समूहों को सूचित करें",
  cockpit_upsell_plus_f3: "आंतरिक ग्रुप चैट सहेजें",
  cockpit_upsell_plus_when_yearly: "वार्षिक भुगतान करने पर",
  cockpit_upsell_plus_size_small: "1–50 कर्मचारी",
  cockpit_upsell_plus_size_large: "51–200 कर्मचारी",
  cockpit_upsell_plus_title: "कंपनियों के लिए Kjuup+",
  cockpit_upsell_plus_text: "कर्मचारियों, लिखने की अनुमतियों और कंपनी संचार को एक ही जगह प्रबंधित करें। आंतरिक चैनल आपकी टीम तक सीमित रहते हैं, बाहरी चैनल आपको प्रोजेक्ट पार्टनर से जोड़ते हैं, और आप विशेष समूहों तक सीधे पहुँच सकते हैं। Kjuup+ के अलावा आप कर्मचारी समूहों के लिए Kjuup.io एक्सेस भी बुक कर सकते हैं। Kjuup+ और Kjuup.io को साथ में इस्तेमाल किया जा सकता है।",
  cockpit_upsell_plus_size: "कंपनी का आकार",
  cockpit_upsell_plus_billing: "बिलिंग",
  cockpit_upsell_plus_per_company: "/ कंपनी · माह, VAT के बिना",
  cockpit_upsell_plus_onboarding: "ऑनबोर्डिंग/परिचय की लागत कंपनी के आकार पर निर्भर करती है",
  cockpit_upsell_plus_larger: "बड़ी कंपनियों के लिए मूल्य अनुरोध पर",
  cockpit_upsell_plus_cta: "बिना बाध्यता के पूछें",
  cockpit_kpi_deadlines_tasks: "समय-सीमाएँ और कार्य",
  cockpit_kpi_appointments: "अपॉइंटमेंट",
  cockpit_room_admin: "प्रोजेक्ट और चैट प्रबंधन",
  cockpit_room_admin_sub: "सभी कंपनी प्रोजेक्ट, सदस्यों, मीडिया और चैट के साथ।",
  pro_todo_not_found: "यह कार्य अब उपलब्ध नहीं है।",
  cockpit_chip_overdue: "अतिदेय",
  cockpit_chip_today: "आज",
  cockpit_calendar_week: "सप्ताह {{week}}",
  cockpit_prev_week: "पिछला सप्ताह",
  cockpit_next_week: "अगला सप्ताह",
  cockpit_chip_requested: "अनुरोधित",
  cockpit_todo_due: "समय-सीमा {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} की ओर से",
  cockpit_todo_since: "{{when}} से",
  cockpit_todo_no_date: "कोई तारीख नहीं",
  cockpit_todo_mark_done: "पूर्ण के रूप में चिह्नित करें",
  cockpit_my_tasks_title: "मेरे कार्य",
  cockpit_today_tasks_group: "आज के कार्य",
  cockpit_assign_none: "किसी को असाइन नहीं किया गया",
  no_project_found: "कोई प्रोजेक्ट नहीं मिला",
  cockpit_row_more_actions: "और कार्रवाइयाँ",
  needs_date: "तारीख असाइन करें",
  cockpit_assign_proposal: "{{name}} पहचाना गया – असाइन करें?",
  cockpit_assign_proposal_confirm: "असाइन करें",
  cockpit_assign_proposal_dismiss: "अनदेखा करें",
  cockpit_priority_date: "तारीख",
  todo_calendar_add: "कैलेंडर में जोड़ें",
  todo_calendar_remove: "कैलेंडर से हटाएँ",
  cockpit_todo_change_project: "प्रोजेक्ट बदलें",
  cockpit_todo_set_date: "तारीख सेट करें",
  pro_todo_done_confirm: "क्या आप वाकई इस कार्य को पूर्ण के रूप में चिह्नित करना चाहते हैं?",
  cockpit_task_delete_failed: "कार्य हटाया नहीं जा सका।",
  cockpit_setup_title: "सेटअप पूरा करें",
  cockpit_setup_text: "तय करें कि आप चैट का उपयोग करना चाहते हैं या नहीं, और Kjuup.io ईमेल क्लाइंट के रूप में काम करे या केवल प्रोजेक्ट और दैनिक रिपोर्ट के साथ।",
  cockpit_setup_cta: "अभी सेट अप करें",
  cockpit_group_tasks: "समय-सीमाएँ और कार्य",
  cockpit_group_appointments: "अपॉइंटमेंट",
  cockpit_report_no_activity: "इस प्रोजेक्ट में पिछले 24 घंटों में कोई नया संदेश या ईमेल नहीं आया।",
  cockpit_report_room_unavailable: "यह प्रोजेक्ट उपलब्ध नहीं है।",
  cockpit_report_create_failed: "दैनिक रिपोर्ट नहीं बनाई जा सकी।",
  cockpit_report_created: "दैनिक रिपोर्ट बनाई गई",
  addon_enable_confirm: "ऐड-ऑन सक्षम करें?",
  addon_enable: "सक्षम करें",
  addon_enabled: "ऐड-ऑन सक्षम हो गया",
  nav_email: "ईमेल",
  nav_my_cockpit: "मेरा कॉकपिट",
  nav_news: "समाचार",
  nav_recommend: "सिफ़ारिश करें",
  pro_todo_status_done: "पूर्ण",
  pro_todo_status_open: "खुला",
  v2_todo_remove: "हटाएँ",
  pro_todo_search_people: "लोग खोजें",
  pro_todo_clear: "साफ़ करें",
  pro_todo_assigned: "(असाइन किया गया)",
  pro_todo_no_people: "कोई व्यक्ति नहीं मिला",
  pro_todo_search_rooms: "प्रोजेक्ट खोजें",
  pro_todo_no_rooms_match: "“{{q}}” से कोई प्रोजेक्ट मेल नहीं खाता",
  pro_todo_no_rooms: "कोई प्रोजेक्ट नहीं मिला",
  pro_todo_activity: "गतिविधि",
  pro_todo_show_less: "कम दिखाएँ",
  pro_todo_show_all: "सभी दिखाएँ ({{n}})",
  pro_todo_due: "समय-सीमा",
  pro_todo_room: "प्रोजेक्ट",
  pro_todo_select_room: "प्रोजेक्ट चुनें",
  pro_todo_status: "स्थिति",
  pro_todo_more: "और",
  pro_todo_edit_title: "कार्य संपादित करें",
  pro_todo_description: "विवरण",
  pro_todo_created_by: "बनाने वाले",
  pro_todo_chat: "चैट",
  navigate_to_source: "स्रोत पर जाएँ",
  todo_calendar_connect_title: "कोई कैलेंडर कनेक्ट नहीं है",
  todo_calendar_connect_body_web: "ToDo जोड़ने के लिए कैलेंडर सिंक सेटिंग्स में कैलेंडर कनेक्ट करें।",
  todo_calendar_connect: "कनेक्ट करें",
  todo_calendar_removed: "आपके कैलेंडर से हटा दिया गया",
  todo_calendar_added_later: "जोड़ा गया। आपका कैलेंडर उपलब्ध नहीं था; Kjuup बाद में फिर कोशिश करेगा।",
  todo_calendar_added: "आपके कैलेंडर में जोड़ा गया",
  todo_calendar_no_date: "केवल तारीख वाला ToDo ही कैलेंडर में जोड़ा जा सकता है।",
  todo_calendar_failed: "आपका कैलेंडर अपडेट नहीं हो सका। कृपया फिर कोशिश करें।",
  todo_calendar_date_title: "अभी कोई तारीख नहीं",
  todo_calendar_date_save: "तारीख सेट करें और जोड़ें",
  todo_calendar_date_body_web: "इस बुकमार्क किए गए कार्य की अभी कोई तारीख नहीं है। इसे अपने कैलेंडर में जोड़ने के लिए तारीख सेट करें।",
  kjuup_io_setup_saved: "सेटअप सहेजा गया",
  kjuup_io_setup_step: "चरण",
  kjuup_io_setup_chats_title: "क्या आप चैट का उपयोग करना चाहते हैं?",
  kjuup_io_setup_email_title: "आप अपने ईमेल कहाँ पढ़ना चाहते हैं?",
  kjuup_io_setup_chats_sub: "सहकर्मियों और प्रोजेक्ट पार्टनर के साथ चैट वैकल्पिक है। आप उन्हें कॉकपिट पर कभी भी दिखा या छिपा सकते हैं।",
  kjuup_io_setup_email_sub: "यह केवल तय करता है कि आप Kjuup में ईमेल क्लाइंट इस्तेमाल करेंगे या अपना मौजूदा ईमेल प्रोग्राम, जैसे Outlook या कोई और, इस्तेमाल करते रहेंगे। आप बाद में बदल सकते हैं।",
  kjuup_io_setup_chats_yes: "हाँ, चैट दिखाएँ",
  kjuup_io_setup_chats_yes_text: "संदेश में चैट और ईमेल शामिल हैं। प्रोजेक्ट में सभी संबंधित लोगों के लिए ग्रुप चैट होती है।",
  kjuup_io_setup_chats_no: "नहीं, चैट के बिना काम करें",
  kjuup_io_setup_chats_no_text: "चैट छिपी रहती हैं। \"संदेश\" \"ईमेल\" बन जाता है; प्रोजेक्ट, कार्य और दैनिक रिपोर्ट बने रहते हैं।",
  kjuup_io_setup_email_client: "Kjuup में ईमेल क्लाइंट",
  kjuup_io_setup_email_client_text: "ईमेल सीधे Kjuup में पढ़ें और जवाब दें।",
  kjuup_io_setup_email_reports: "मौजूदा ईमेल क्लाइंट",
  kjuup_io_setup_email_reports_text: "अपने मौजूदा प्रोग्राम, जैसे Outlook या कोई और, में पढ़ना और जवाब देना जारी रखें।",
  kjuup_io_setup_skip: "बाद में",
  next: "आगे",
  kjuup_io_setup_finish: "सेटअप पूरा करें",
  today_label: "आज",
  tomorrow_label: "कल",
  cockpit_todo_overdue: "अतिदेय",
  cockpit_report_management_fazit: "प्रबंधन सारांश",
  cockpit_todo_appointment: "अपॉइंटमेंट",
  cockpit_todo_deadline: "समय-सीमा",
  cockpit_todo_deadline_define: "समय-सीमा तय करें",
  pro_todo_status_acknowledged: "पुष्टि की गई",
  pro_todo_responsible: "ज़िम्मेदार",
  pro_todo_notice_confirmed: "चैट में पुष्टि की गई",
  pro_todo_notice_sent_at: "संदेश भेजा गया",
  pro_todo_notice_again: "संदेश फिर से भेजें",
  pro_todo_notice_send: "Kjuup संदेश के ज़रिए सूचित करें",
  pro_todo_add_assignee: "जोड़ें",
  pro_todo_edit: "संपादित करें",
  pro_todo_change_room: "प्रोजेक्ट बदलें",
  pro_todo_due_on: "देय तिथि",
  pro_todo_edit_due: "देय तिथि संपादित करें",
  pro_todo_no_date: "कोई तारीख नहीं",
  pro_todo_edit_description: "विवरण संपादित करें",
  pro_todo_no_description: "अभी कोई विवरण नहीं",
  pro_todo_title_label: "शीर्षक",
  pro_todo_title_placeholder: "शीर्षक दर्ज करें...",
  pro_todo_task: "कार्य",
  pro_todo_what: "क्या करना है?",
  pro_todo_source_email: "ईमेल",
  pro_todo_sources: "स्रोत",
  previous: "पिछला",
  kjuup_plus_abo_tier_large: "Kjuup+ Large ({max} कर्मचारियों तक)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small ({max} कर्मचारियों तक)",
  kjuup_plus_abo_status_ends: "{date} को समाप्त",
  kjuup_plus_abo_seats_over: "{max} से अधिक कर्मचारी – Kjuup आपसे एक व्यक्तिगत ऑफ़र के साथ संपर्क करेगा।",
  kjuup_plus_abo_seats_next: "अधिक कर्मचारी जुड़ने पर पैकेज अपने आप {next} में बदल जाएगा (आनुपातिक शुल्क)।",
  kjuup_plus_abo_seats_used: "{total} में से {used} सीटें उपयोग में",
  kjuup_plus_abo_seats_free: "{count} सीटें बाकी",
  kjuup_plus_abo_intro_until: "{date} तक",
  kjuup_plus_abo_invoice_open: "बकाया · देय {date}",
  kjuup_plus_abo_invoices_all: "सभी {count} दिखाएँ",
  kjuup_plus_abo_requested_hint: "{date} को रद्दीकरण का अनुरोध किया गया। Kjuup अवधि के अंत ({end}) पर इसकी पुष्टि करेगा।",
  kjuup_plus_abo_cancel_hint: "Kjuup आपके अनुरोध की समीक्षा करेगा और अवधि के अंत ({end}) पर रद्दीकरण की पुष्टि करेगा। तब तक Kjuup+ सक्रिय रहेगा।",
  kjuup_plus_abo_withdrawn: "रद्दीकरण अनुरोध वापस लिया गया",
  kjuup_plus_abo_requested: "रद्दीकरण का अनुरोध किया गया",
  cockpit_upsell_plus_intro_hint: "पहले {months} महीने, फिर {price}",
  cockpit_upsell_plus_badge: "{months} महीनों के लिए परिचयात्मक मूल्य",
  calendar_syncing: "कैलेंडर से अपडेट हो रहा है…",
  calendar_sync_up_to_date: "कैलेंडर अद्यतन है",
  calendar_sync_failed: "सिंक विफल रहा",
  delete_multiple_tasks_confirm: "क्या आप वाकई {count} ToDo हटाना चाहते हैं?",
  todos_deleted_count: "{count} ToDo हटाए गए",
  todos_deleted_partial: "{ok} ToDo हटाए गए, {fail} विफल",
  todo_unknown: "अज्ञात",
  todo_created_from_message: "इस संदेश से कार्य बनाया गया",
  kjuup_io_todo_calendar_trial_ended_note: "कैलेंडर सिंक · सदस्यता लें",
  kjuup_io_todo_calendar_nudge: "इस टूडू को अपने कैलेंडर से सिंक करें?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io सक्रिय करें",
  todo_confirmed: "ToDo पुष्टि की गई",
  pro_todo_bulk_delete_title: "{{n}} कार्य हटाएँ?",
  pro_todo_previous_none_own: "ये लंबित कार्य आपको दूसरों ने सौंपे हैं और केवल वही इन्हें हटा सकते हैं।",
  pro_todo_previous_none: "कोई लंबित कार्य नहीं",
  pro_todo_previous_title: "{{n}} लंबित कार्य हटाएँ?",
  pro_todo_previous_text: "पिछले दिनों के आपके सभी खुले कार्य हटा दिए जाएँगे।",
  pro_todo_previous_skipped: "दूसरों द्वारा सौंपे गए {{n}} कार्य बने रहेंगे।",
  unassign_task_confirm: "क्या आप इस कार्य से अपना असाइनमेंट रद्द करना चाहते हैं?",
  unassign_label: "रद्द करें",
  pro_todo_delete_title: "कार्य हटाएँ",
  pro_todo_today: "आज",
  pro_todo_yesterday: "कल",
  pro_todo_since_yesterday: "कल से",
  pro_todo_mark_open: "खुला चिह्नित करें",
  verify_completion: "सत्यापित करें",
  new_label: "नया",
  bookmarked_no_mylist: "बुकमार्क किए गए कार्य मेरी सूची में नहीं जोड़े जा सकते",
  delete_only_own: "आप केवल अपने बनाए हुए कार्य ही हटा सकते हैं",
  todo_clear_all: "सभी हटाएं",
  pro_todo_of_completed: "{{total}} में से {{done}} पूर्ण",
  pro_todo_pick_date: "तारीख चुनें",
  pro_todo_show_day: "दिन दिखाएँ",
  todo_adjust_list: "सूची समायोजित करें",
  pro_todo_section_upcoming: "आगामी",
  pro_todo_section_done: "पूर्ण",
  pro_todo_room_empty_today: "इस प्रोजेक्ट में आज कोई कार्य नहीं",
  pro_todo_room_empty_day: "इस प्रोजेक्ट में इस दिन कोई कार्य नहीं",
  pro_todo_delete_previous: "सभी हटाएँ",
  todo_my_list_empty: "आपका दिन खाली है",
  todo_my_list_empty_hint: "कार्य जोड़ने के लिए “सूची समायोजित करें” पर क्लिक करें",
  pro_todo_empty_title: "यहाँ कुछ नहीं है",
  pro_todo_empty_hint: "इस दृश्य से मेल खाता कोई कार्य नहीं।",
  pro_todo_selected: "{{n}} चयनित",
  delete_selected_count: "हटाएं ({count})",
  pro_todo_adjust_done: "हो गया",
  pro_todo_deleting: "हटाया जा रहा है...",
  pro_todo_reopen: "कार्य फिर से खोलें",
  pro_todo_step_done: "पूर्ण",
  move_back_in_progress: "वापस प्रगति में ले जाएँ",
  pro_todo_mark_not_started: "शुरू नहीं हुआ चिह्नित करें",
  back_into_in_progress: "वापस प्रगति में",
  pro_todo_mark_in_progress: "प्रगति में चिह्नित करें",
  unassign_todo: "ToDo असाइनमेंट रद्द करें",
  pro_todo_open_room: "प्रोजेक्ट खोलें",
  pro_todo_new_task: "नया कार्य",
  select_user_back_to_in_progress: "प्रगति में वापस ले जाने के लिए उपयोगकर्ता चुनें",
  cockpit_email_accounts_n_many: "{{n}} खाते कनेक्टेड",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup संपर्क",
  combined_tab_teams: "Teams संपर्क",
  combined_bridge_failed: "Teams कॉपी नहीं बनाई जा सकी।",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup और Teams संपर्क: एक नया समूह बनाया जाएगा जो Microsoft Teams में भी दिखेगा।",
  teams_new_chat_title: "नई Teams चैट",
  teams_new_chat_topic: "समूह का नाम (वैकल्पिक)",
  teams_new_chat_start: "चैट शुरू करें",
  teams_new_chat_creating: "चैट बनाई जा रही है…",
  teams_new_chat_forbidden: "Microsoft Teams इस चैट की अनुमति नहीं देता (जैसे आपके संगठन के बाहर का व्यक्ति या आपके IT की कोई नीति)।",
  teams_new_chat_too_many: "एक चैट के लिए बहुत अधिक लोग।",
  teams_new_chat_type_hint: "अपने संगठन में खोजने के लिए कोई नाम लिखें।",
  teams_new_chat_directory_forbidden: "आपका संगठन निर्देशिका में खोज की अनुमति नहीं देता। केवल आपकी Teams चैट के लोग दिखाए गए हैं।",
  teams_new_chat_account: "खाता",
};
